import React, { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseClient";
import MagnetOrder from "./MagnetOrder";


// ...existing code...
const EMPTY_LOGO_URL = "https://axfkablwysnukojhymip.supabase.co/storage/v1/object/public/public_assets/Dringocean_Logo.png";
// ...existing code...
// ...existing code...

// --- FELSŐ NAVIGÁCIÓS SÁV (KÉK ALÁHÚZÁSSAL, KÖZÉPEN) ---
function TopNavBar({ items, active, onSelect }) {
  return (
    <nav
      style={{
        borderBottom: "1px solid #222", // <-- vastagabb, fekete vonal
        background: "#fff",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 48,
        marginBottom: 0,
      }}
    >
      <ul
        style={{
          display: "flex",
          gap: 28,
          padding: 0,
          margin: 0,
          listStyle: "none",
          alignItems: "flex-end",
          position: "relative",
        }}
      >
        {items.map((item, idx) => (
          <li key={item.key || idx} style={{ position: "relative", height: 48 }}>
            {item.onClick || onSelect ? (
              <button
                onClick={() => (item.onClick ? item.onClick() : onSelect?.(item.key))}
                style={{
                  background: "none",
                  border: "none",
                  outline: "none",
                  color: active === item.key ? "#4f8cff" : "#2d3a4a",
                  fontWeight: 600,
                  fontSize: "1.08rem",
                  padding: "0 14px",
                  height: 44,
                  cursor: "pointer",
                  borderRadius: 8,
                  transition: "background 0.15s, color 0.15s",
                  position: "relative",
                  zIndex: 1,
                }}
                onMouseOver={e => (e.currentTarget.style.background = "#f5f6fa")}
                onMouseOut={e => (e.currentTarget.style.background = "none")}
              >
                {item.label}
                {active === item.key && (
                  <span
                    style={{
                      display: "block",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: -1,
                      height: 3,
                      background: "#4f8cff",
                      borderRadius: 2,
                      zIndex: 2,
                    }}
                  />
                )}
              </button>
            ) : (
              <span
                style={{
                  display: "inline-block",
                  color: active === item.key ? "#4f8cff" : "#2d3a4a",
                  fontWeight: 600,
                  fontSize: "1.08rem",
                  padding: "0 14px",
                  height: 44,
                  lineHeight: "44px",
                  borderRadius: 8,
                  position: "relative",
                  cursor: "default",
                  background: "none",
                }}
              >
                {item.label}
                {active === item.key && (
                  <span
                    style={{
                      display: "block",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: -1,
                      height: 3,
                      background: "#4f8cff",
                      borderRadius: 2,
                      zIndex: 2,
                    }}
                  />
                )}
              </span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

// Felhasználási feltételek modal
function TermsModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(44,62,80,0.18)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff", borderRadius: 28, padding: 36, minWidth: 320, maxWidth: 700, boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
        display: "flex", flexDirection: "column", alignItems: "center", position: "relative", maxHeight: "80vh", overflowY: "auto"
      }}>
        <button onClick={onClose} style={{
          position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#4f8cff"
        }}>×</button>
        <h2 style={{ fontWeight: 800, fontSize: "1.3rem", marginBottom: 18, color: "#2d3a4a" }}>Felhasználási feltételek</h2>
        <div style={{ fontSize: "1rem", color: "#2d3a4a", textAlign: "left", maxWidth: 600 }}>
          {/* ...szabályzat szöveg... */}
          <p>
            <b>1. General Provisions</b><br />
            By using the Dringocean application, you agree to the following terms of use. The application is intended solely for educational purposes, and all users are required to comply with these terms. Use of the application is voluntary, and you may discontinue use at any time.
            <br /><br />
            The developer reserves the right to modify these terms at any time. Changes will take effect immediately upon publication within the application.
          </p>
          <p>
            <b>2. Privacy and Data Protection</b><br />
            The application does not collect, store, or share any personal data with third parties. Your email address is used exclusively for identification and login purposes and will not be used for marketing or other purposes. The application does not track, profile, or analyze user behavior.
            <br /><br />
            The developer is committed to data protection and takes all necessary technical and organizational measures to keep your data secure. The application complies with the General Data Protection Regulation (GDPR) and relevant local laws.
          </p>
          <p>
            <b>3. Data Security</b><br />
            All reasonable technical measures are taken to ensure the security of your data. Data is stored in encrypted form and is only used as authorized by you. The developer is not liable for data loss resulting from third-party attacks or force majeure events.
            <br /><br />
            Regular backups are performed, and system integrity is continuously monitored. In case of data loss or breach, the developer will make every effort to restore data but accepts no liability for direct or indirect damages.
          </p>
          <p>
            <b>4. Disclaimer of Liability</b><br />
            The developer is not liable for any direct or indirect damages resulting from the use, malfunction, unavailability, or technical issues of the application. All content is provided for informational purposes only and does not constitute official advice.
            <br /><br />
            The accuracy, completeness, and timeliness of the content cannot be guaranteed. Users are solely responsible for any legal, financial, or other consequences arising from the use of the application.
          </p>
          <p>
            <b>5. Content and Copyright</b><br />
            All content (text, audio, images, code) within the application is the property of the developer or rights holder. Unauthorized copying, distribution, or modification of content is prohibited. Users may use materials solely for personal educational purposes.
            <br /><br />
            Content is protected by copyright law. Commercial use, resale, or distribution is not permitted. Violations may result in legal consequences.
            <br /><br />
            If you upload your own content, you declare that you have the necessary rights and that your content does not infringe the rights of third parties.
          </p>
          <p>
            <b>6. User Conduct</b><br />
            It is prohibited to post or distribute illegal, offensive, harassing, or otherwise harmful content within the application. The developer reserves the right to remove such content and exclude the user from the application without prior notice.
            <br /><br />
            Users must act respectfully, lawfully, and ethically. Spam, advertisements, viruses, or other harmful content are strictly forbidden.
          </p>
          <p>
            <b>7. Modifications</b><br />
            The developer reserves the right to modify the terms of use, features, content, and rules of the application at any time. Users are required to regularly review the terms. Continued use of the application constitutes acceptance of any changes.
          </p>
          <p>
            <b>8. Contact</b><br />
            For any questions or feedback, the developer can be reached at info@dringocean.com. The developer aims to respond to all user inquiries as quickly as possible.
          </p>
          <p>
            <b>9. Legal Protection</b><br />
            The developer will take all necessary legal steps to protect its own rights and those of users. By using the application, you agree not to make any legal claims against the developer for damages resulting from use of the application.
          </p>
          <p>
            <b>10. Development Status</b><br />
            <u>Dringocean is currently under active development.</u> Some features, content, and information may be incomplete, inaccurate, or subject to change. The developer does not guarantee that all information provided in the application reflects reality or is up to date. Please use the application with this in mind and report any issues or inaccuracies to the developer.
          </p>
          <p>
            <b>11. Final Provisions</b><br />
            Use of the application is voluntary. If you do not agree with the terms, please do not use the application. These terms are governed by Hungarian law. In case of disputes, parties will seek amicable resolution; failing that, Hungarian courts have jurisdiction.
          </p>
        </div>
      </div>
    </div>
  );
}

// ...importok után...



const LANGS = [
  { key: "english", label: { english: "English", hungarian: "Angol", serbian: "Енглески", spanish: "Inglés" } },
  { key: "hungarian", label: { english: "Hungarian", hungarian: "Magyar", serbian: "Мађарски", spanish: "Húngaro" } },
  { key: "serbian", label: { english: "Serbian", hungarian: "Szerb", serbian: "Српски", spanish: "Serbio" } },
  { key: "spanish", label: { english: "Spanish", hungarian: "Spanyol", serbian: "Шпански", spanish: "Español" } },
  { key: "french", label: { english: "French", hungarian: "Francia", serbian: "Француски", spanish: "Francés" } },
  { key: "german", label: { english: "German", hungarian: "Német", serbian: "Немачки", spanish: "Alemán" } },
  { key: "japanese", label: { english: "Japanese", hungarian: "Japán", serbian: "Јапански", spanish: "Japonés" } },
  { key: "korean", label: { english: "Korean", hungarian: "Koreai", serbian: "Корејски", spanish: "Coreano" } },
  { key: "italian", label: { english: "Italian", hungarian: "Olasz", serbian: "Италијански", spanish: "Italiano" } },
  { key: "hindi", label: { english: "Hindi", hungarian: "Hindi", serbian: "Хинди", spanish: "Hindi" } },
  { key: "chinese", label: { english: "Chinese (Mandarin)", hungarian: "Kínai", serbian: "Кинески", spanish: "Chino" } },
  { key: "portuguese", label: { english: "Portuguese", hungarian: "Portugál", serbian: "Португалски", spanish: "Portugués" } },
  { key: "arabic", label: { english: "Arabic", hungarian: "Arab", serbian: "Арапски", spanish: "Árabe" } },
  { key: "bengali", label: { english: "Bengali", hungarian: "Bengáli", serbian: "Бенгалски", spanish: "Bengalí" } },
  { key: "russian", label: { english: "Russian", hungarian: "Orosz", serbian: "Руски", spanish: "Ruso" } },
  { key: "punjabi", label: { english: "Punjabi", hungarian: "Pandzsábi", serbian: "Панџаби", spanish: "Panyabí" } },
  { key: "javanese", label: { english: "Javanese", hungarian: "Jávai", serbian: "Јавански", spanish: "Javanés" } },
  { key: "vietnamese", label: { english: "Vietnamese", hungarian: "Vietnámi", serbian: "Вијетнамски", spanish: "Vietnamita" } },
  { key: "tamil", label: { english: "Tamil", hungarian: "Tamil", serbian: "Тамилски", spanish: "Tamil" } },
  { key: "urdu", label: { english: "Urdu", hungarian: "Urdu", serbian: "Урду", spanish: "Urdu" } },
  { key: "turkish", label: { english: "Turkish", hungarian: "Török", serbian: "Турски", spanish: "Turco" } },
  { key: "persian", label: { english: "Persian (Farsi)", hungarian: "Perzsa", serbian: "Персијски", spanish: "Persa" } },
  { key: "polish", label: { english: "Polish", hungarian: "Lengyel", serbian: "Пољски", spanish: "Polaco" } },
  { key: "dutch", label: { english: "Dutch", hungarian: "Holland", serbian: "Холандски", spanish: "Neerlandés" } },
  { key: "ukrainian", label: { english: "Ukrainian", hungarian: "Ukrán", serbian: "Украјински", spanish: "Ucraniano" } },
  { key: "romanian", label: { english: "Romanian", hungarian: "Román", serbian: "Румунски", spanish: "Rumano" } },
  { key: "greek", label: { english: "Greek", hungarian: "Görög", serbian: "Грчки", spanish: "Griego" } },
  { key: "czech", label: { english: "Czech", hungarian: "Cseh", serbian: "Чешки", spanish: "Checo" } },
  { key: "swedish", label: { english: "Swedish", hungarian: "Svéd", serbian: "Шведски", spanish: "Sueco" } },
  { key: "bulgarian", label: { english: "Bulgarian", hungarian: "Bolgár", serbian: "Бугарски", spanish: "Búlgaro" } },
  { key: "danish", label: { english: "Danish", hungarian: "Dán", serbian: "Дански", spanish: "Danés" } },
  { key: "finnish", label: { english: "Finnish", hungarian: "Finn", serbian: "Фински", spanish: "Finlandés" } },
  { key: "slovak", label: { english: "Slovak", hungarian: "Szlovák", serbian: "Словачки", spanish: "Eslovaco" } },
  { key: "hebrew", label: { english: "Hebrew", hungarian: "Héber", serbian: "Хебрејски", spanish: "Hebreo" } },
  { key: "thai", label: { english: "Thai", hungarian: "Thai", serbian: "Тајландски", spanish: "Tailandés" } },
  { key: "croatian", label: { english: "Croatian", hungarian: "Horvát", serbian: "Хрватски", spanish: "Croata" } },
  { key: "lithuanian", label: { english: "Lithuanian", hungarian: "Litván", serbian: "Литвански", spanish: "Lituano" } },
  { key: "latvian", label: { english: "Latvian", hungarian: "Lett", serbian: "Летонски", spanish: "Letón" } },
  { key: "estonian", label: { english: "Estonian", hungarian: "Észt", serbian: "Естонски", spanish: "Estonio" } },
  { key: "icelandic", label: { english: "Icelandic", hungarian: "Izlandi", serbian: "Исландски", spanish: "Islandés" } },
  { key: "malay", label: { english: "Malay", hungarian: "Maláj", serbian: "Малајски", spanish: "Malayo" } },
  { key: "burmese", label: { english: "Burmese", hungarian: "Burmai", serbian: "Бурмански", spanish: "Birmano" } },
  { key: "nepali", label: { english: "Nepali", hungarian: "Nepáli", serbian: "Непалски", spanish: "Nepalí" } },
  { key: "khmer", label: { english: "Khmer", hungarian: "Khmer", serbian: "Кмерски", spanish: "Jemer" } },
  { key: "lao", label: { english: "Lao", hungarian: "Lao", serbian: "Лаошки", spanish: "Lao" } },
  { key: "sinhala", label: { english: "Sinhala", hungarian: "Szingaléz", serbian: "Синхалски", spanish: "Cingalés" } },
  { key: "amharic", label: { english: "Amharic", hungarian: "Amhara", serbian: "Амхарски", spanish: "Amhárico" } },
  { key: "swahili", label: { english: "Swahili", hungarian: "Szuahéli", serbian: "Свахили", spanish: "Suajili" } },
  { key: "hausa", label: { english: "Hausa", hungarian: "Hausza", serbian: "Хауса", spanish: "Hausa" } },
  { key: "yoruba", label: { english: "Yoruba", hungarian: "Joruba", serbian: "Јоруба", spanish: "Yoruba" } }
];

const UI_LANGS = [
  { key: "english", label: "English" },
  { key: "hungarian", label: "Magyar" },
  { key: "serbian", label: "Српски" },
  { key: "spanish", label: "Español" },
  { key: "french", label: "Français" },
  { key: "german", label: "Deutsch" },
  { key: "chinese", label: "中文" },
  { key: "russian", label: "Русский" },
  { key: "arabic", label: "العربية" },
  { key: "portuguese", label: "Português" },
  { key: "ukrainian", label: "Українська" },
  { key: "hindi", label: "हिन्दी" },
  { key: "japanese", label: "日本語" }
];

const defaultUiWords = {
  login: {
    english: "Login",
    hungarian: "Bejelentkezés",
    serbian: "Пријава",
    spanish: "Iniciar sesión",
    french: "Connexion",
    german: "Anmelden",
    chinese: "登录",
    russian: "Войти",
    arabic: "تسجيل الدخول",
    portuguese: "Entrar",
    ukrainian: "Увійти",
    hindi: "लॉगिन",
    japanese: "ログイン"
  },
  register: {
    english: "Register",
    hungarian: "Regisztráció",
    serbian: "Регистрација",
    spanish: "Registrarse",
    french: "S'inscrire",
    german: "Registrieren",
    chinese: "注册",
    russian: "Регистрация",
    arabic: "تسجيل",
    portuguese: "Registrar",
    ukrainian: "Зареєструватися",
    hindi: "रजिस्टर करें",
    japanese: "登録"
  },
  email: {
    english: "Email",
    hungarian: "Email",
    serbian: "Е-пошта",
    spanish: "Correo electrónico",
    french: "E-mail",
    german: "E-Mail",
    chinese: "电子邮件",
    russian: "Эл. почта",
    arabic: "البريد الإلكتروني",
    portuguese: "E-mail",
    ukrainian: "Електронна пошта",
    hindi: "ईमेल",
    japanese: "メール"
  },
  password: {
    english: "Password",
    hungarian: "Jelszó",
    serbian: "Лозинка",
    spanish: "Contraseña",
    french: "Mot de passe",
    german: "Passwort",
    chinese: "密码",
    russian: "Пароль",
    arabic: "كلمة المرور",
    portuguese: "Senha",
    ukrainian: "Пароль",
    hindi: "पासवर्ड",
    japanese: "パスワード"
  },
  logout: {
    english: "Logout",
    hungarian: "Kijelentkezés",
    serbian: "Одјава",
    spanish: "Cerrar sesión",
    french: "Déconnexion",
    german: "Abmelden",
    chinese: "退出",
    russian: "Выйти",
    arabic: "تسجيل الخروج",
    portuguese: "Sair",
    ukrainian: "Вийти",
    hindi: "लॉगआउट",
    japanese: "ログアウト"
  },
  hello: {
    english: "Hello",
    hungarian: "Szia",
    serbian: "Здраво",
    spanish: "Hola",
    french: "Bonjour",
    german: "Hallo",
    chinese: "你好",
    russian: "Здравствуйте",
    arabic: "مرحبا",
    portuguese: "Olá",
    ukrainian: "Привіт",
    hindi: "नमस्ते",
    japanese: "こんにちは"
  },
  select_languages: {
    english: "Select your languages",
    hungarian: "Válassz nyelveket",
    serbian: "Изаберите језике",
    spanish: "Selecciona tus idiomas",
    french: "Sélectionnez vos langues",
    german: "Wählen Sie Ihre Sprachen",
    chinese: "选择你的语言",
    russian: "Выберите ваши языки",
    arabic: "اختر لغاتك",
    portuguese: "Selecione seus idiomas",
    ukrainian: "Виберіть свої мови",
    hindi: "अपनी भाषाएँ चुनें",
    japanese: "言語を選択してください"
  },
  source_language: {
    english: "Source language",
    hungarian: "Forrásnyelv",
    serbian: "Изворни језик",
    spanish: "Idioma de origen",
    french: "Langue source",
    german: "Ausgangssprache",
    chinese: "源语言",
    russian: "Исходный язык",
    arabic: "اللغة المصدر",
    portuguese: "Idioma de origem",
    ukrainian: "Мова джерела",
    hindi: "स्रोत भाषा",
    japanese: "元の言語"
  },
  target_language: {
    english: "Target language",
    hungarian: "Célnyelv",
    serbian: "Циљни језик",
    spanish: "Idioma de destino",
    french: "Langue cible",
    german: "Zielsprache",
    chinese: "目标语言",
    russian: "Целевой язык",
    arabic: "اللغة الهدف",
    portuguese: "Idioma alvo",
    ukrainian: "Мова призначення",
    hindi: "लक्ष्य भाषा",
    japanese: "目標言語"
  },
  continue: {
    english: "Continue",
    hungarian: "Tovább",
    serbian: "Настави",
    spanish: "Continuar",
    french: "Continuer",
    german: "Weiter",
    chinese: "继续",
    russian: "Продолжить",
    arabic: "متابعة",
    portuguese: "Continuar",
    ukrainian: "Продовжити",
    hindi: "जारी रखें",
    japanese: "続ける"
  },
  select_chapter: {
    english: "Select a chapter",
    hungarian: "Válassz fejezetet",
    serbian: "Изаберите поглавље",
    spanish: "Selecciona un capítulo",
    french: "Sélectionnez un chapitre",
    german: "Kapitel auswählen",
    chinese: "选择章节",
    russian: "Выберите главу",
    arabic: "اختر فصلًا",
    portuguese: "Selecione um capítulo",
    ukrainian: "Виберіть розділ",
    hindi: "अध्याय चुनें",
    japanese: "章を選択"
  },
  back_to_languages: {
    english: "Back to language selection",
    hungarian: "Vissza a nyelvválasztóhoz",
    serbian: "Назад на избор језика",
    spanish: "Volver a la selección de idioma",
    french: "Retour à la sélection de la langue",
    german: "Zurück zur Sprachauswahl",
    chinese: "返回语言选择",
    russian: "Назад к выбору языка",
    arabic: "العودة لاختيار اللغة",
    portuguese: "Voltar à seleção de idioma",
    ukrainian: "Назад до вибору мови",
    hindi: "भाषा चयन पर वापस जाएँ",
    japanese: "言語選択に戻る"
  },
  back_to_chapters: {
    english: "Back to chapters",
    hungarian: "Vissza a fejezetekhez",
    serbian: "Назад на поглавља",
    spanish: "Volver a los capítulos",
    french: "Retour aux chapitres",
    german: "Zurück zu den Kapiteln",
    chinese: "返回章节",
    russian: "Назад к главам",
    arabic: "العودة للفصول",
    portuguese: "Voltar aos capítulos",
    ukrainian: "Назад до розділів",
    hindi: "अध्यायों पर वापस जाएँ",
    japanese: "章に戻る"
  },
  next: {
    english: "Next",
    hungarian: "Következő",
    serbian: "Следећи",
    spanish: "Siguiente",
    french: "Suivant",
    german: "Weiter",
    chinese: "下一步",
    russian: "Далее",
    arabic: "التالي",
    portuguese: "Próximo",
    ukrainian: "Далі",
    hindi: "अगला",
    japanese: "次へ"
  },
  previous: {
    english: "Previous",
    hungarian: "Előző",
    serbian: "Претходни",
    spanish: "Anterior",
    french: "Précédent",
    german: "Zurück",
    chinese: "上一步",
    russian: "Предыдущий",
    arabic: "السابق",
    portuguese: "Anterior",
    ukrainian: "Попередній",
    hindi: "पिछला",
    japanese: "前へ"
  },
  start_test: {
    english: "Start test",
    hungarian: "Teszt indítása",
    serbian: "Покрени тест",
    spanish: "Iniciar prueba",
    french: "Commencer le test",
    german: "Test starten",
    chinese: "开始测试",
    russian: "Начать тест",
    arabic: "بدء الاختبار",
    portuguese: "Iniciar teste",
    ukrainian: "Почати тест",
    hindi: "परीक्षण शुरू करें",
    japanese: "テスト開始"
  },
  submit: {
    english: "Check",
    hungarian: "Ellenőrzés",
    serbian: "Провери",
    spanish: "Comprobar",
    french: "Vérifier",
    german: "Prüfen",
    chinese: "检查",
    russian: "Проверить",
    arabic: "تحقق",
    portuguese: "Verificar",
    ukrainian: "Перевірити",
    hindi: "जांचें",
    japanese: "確認"
  },
  try_again: {
    english: "Try again",
    hungarian: "Újra",
    serbian: "Покушај поново",
    spanish: "Intentar de nuevo",
    french: "Réessayer",
    german: "Erneut versuchen",
    chinese: "再试一次",
    russian: "Попробовать снова",
    arabic: "حاول مرة أخرى",
    portuguese: "Tente novamente",
    ukrainian: "Спробуйте ще раз",
    hindi: "फिर से प्रयास करें",
    japanese: "もう一度試す"
  },
  test_perfect: {
    english: "You can only continue if all matches are correct!",
    hungarian: "Csak akkor léphetsz tovább, ha minden párosítás helyes!",
    serbian: "Можете наставити само ако су сва повезивања тачна!",
    spanish: "¡Solo puedes continuar si todas las coincidencias son correctas!",
    french: "Vous ne pouvez continuer que si toutes les correspondances sont correctes !",
    german: "Du kannst nur fortfahren, wenn alle Zuordnungen korrekt sind!",
    chinese: "只有所有匹配正确才能继续！",
    russian: "Вы можете продолжить только если все совпадения верны!",
    arabic: "يمكنك المتابعة فقط إذا كانت جميع المطابقات صحيحة!",
    portuguese: "Você só pode continuar se todas as correspondências estiverem corretas!",
    ukrainian: "Ви можете продовжити лише якщо всі відповідності правильні!",
    hindi: "आप तभी आगे बढ़ सकते हैं जब सभी मेल सही हों!",
    japanese: "すべての一致が正しい場合のみ続行できます！"
  },
  test_fill_all: {
    english: "Please fill all fields!",
    hungarian: "Minden mezőt tölts ki!",
    serbian: "Попуните сва поља!",
    spanish: "¡Por favor, rellena todos los campos!",
    french: "Veuillez remplir tous les champs !",
    german: "Bitte füllen Sie alle Felder aus!",
    chinese: "请填写所有字段！",
    russian: "Пожалуйста, заполните все поля!",
    arabic: "يرجى ملء جميع الحقول!",
    portuguese: "Por favor, preencha todos os campos!",
    ukrainian: "Будь ласка, заповніть всі поля!",
    hindi: "कृपया सभी फ़ील्ड भरें!",
    japanese: "すべての項目を入力してください！"
  },
  chapters: {
    english: "Chapters",
    hungarian: "Fejezetek",
    serbian: "Поглавља",
    spanish: "Capítulos",
    french: "Chapitres",
    german: "Kapitel",
    chinese: "章节",
    russian: "Главы",
    arabic: "الفصول",
    portuguese: "Capítulos",
    ukrainian: "Розділи",
    hindi: "अध्याय",
    japanese: "章"
  },
  test: {
    english: "Test",
    hungarian: "Teszt",
    serbian: "Тест",
    spanish: "Prueba",
    french: "Test",
    german: "Test",
    chinese: "测试",
    russian: "Тест",
    arabic: "اختبار",
    portuguese: "Teste",
    ukrainian: "Тест",
    hindi: "परीक्षण",
    japanese: "テスト"
  },
  completed: {
    english: "Completed",
    hungarian: "Teljesítve",
    serbian: "Завршено",
    spanish: "Completado",
    french: "Terminé",
    german: "Abgeschlossen",
    chinese: "已完成",
    russian: "Завершено",
    arabic: "مكتمل",
    portuguese: "Concluído",
    ukrainian: "Завершено",
    hindi: "पूर्ण",
    japanese: "完了"
  },
  pick_your_wish: {
    english: "Pick your wish!",
    hungarian: "Válassz nyelvet!",
    serbian: "Изаберите жељу!",
    spanish: "¡Elige tu deseo!",
    french: "Choisissez votre souhait !",
    german: "Wähle deinen Wunsch!",
    chinese: "选择你的愿望！",
    russian: "Выберите свое желание!",
    arabic: "اختر أمنيتك!",
    portuguese: "Escolha seu desejo!",
    ukrainian: "Виберіть своє бажання!",
    hindi: "अपनी इच्छा चुनें!",
    japanese: "願いを選んでください！"
  },
  back: {
    english: "Back",
    hungarian: "Vissza",
    serbian: "Назад",
    spanish: "Atrás",
    french: "Retour",
    german: "Zurück",
    chinese: "返回",
    russian: "Назад",
    arabic: "رجوع",
    portuguese: "Voltar",
    ukrainian: "Назад",
    hindi: "वापस",
    japanese: "戻る"
  },
  registration_success: {
    english: "Registration successful! Please check your email to confirm.",
    hungarian: "Sikeres regisztráció! Nézd meg az emailed a megerősítéshez.",
    serbian: "Успешна регистрација! Проверите свој е-маил за потврду.",
    spanish: "¡Registro exitoso! Por favor, revisa tu correo electrónico para confirmar.",
    french: "Inscription réussie ! Veuillez vérifier votre e-mail pour confirmer.",
    german: "Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mail zur Bestätigung.",
    chinese: "注册成功！请检查您的电子邮件以确认。",
    russian: "Регистрация успешна! Пожалуйста, проверьте свою почту для подтверждения.",
    arabic: "تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني للتأكيد.",
    portuguese: "Registro bem-sucedido! Por favor, verifique seu e-mail para confirmar.",
    ukrainian: "Реєстрація успішна! Перевірте свою електронну пошту для підтвердження.",
    hindi: "पंजीकरण सफल! कृपया पुष्टि के लिए अपना ईमेल देखें।",
    japanese: "登録成功！確認のためメールをご確認ください。"
  },
  already_have_account: {
    english: "Already have an account? Login!",
    hungarian: "Van már fiókod? Jelentkezz be!",
    serbian: "Већ имате налог? Пријавите се!",
    spanish: "¿Ya tienes una cuenta? ¡Inicia sesión!",
    french: "Vous avez déjà un compte ? Connectez-vous !",
    german: "Sie haben bereits ein Konto? Anmelden!",
    chinese: "已有账户？登录！",
    russian: "Уже есть аккаунт? Войти!",
    arabic: "لديك حساب بالفعل؟ سجل الدخول!",
    portuguese: "Já tem uma conta? Entre!",
    ukrainian: "Вже маєте акаунт? Увійдіть!",
    hindi: "पहले से खाता है? लॉगिन करें!",
    japanese: "すでにアカウントがありますか？ログイン！"
  },
  no_account: {
    english: "No account? Register!",
    hungarian: "Nincs fiókod? Regisztrálj!",
    serbian: "Немате налог? Региструјте се!",
    spanish: "¿No tienes cuenta? ¡Regístrate!",
    french: "Pas de compte ? Inscrivez-vous !",
    german: "Kein Konto? Registrieren!",
    chinese: "没有账户？注册！",
    russian: "Нет аккаунта? Зарегистрируйтесь!",
    arabic: "ليس لديك حساب؟ سجل!",
    portuguese: "Não tem conta? Registre-se!",
    ukrainian: "Немає акаунта? Зареєструйтесь!",
    hindi: "कोई खाता नहीं? रजिस्टर करें!",
    japanese: "アカウントがありませんか？登録！"
  },
  please_choose: {
    english: "Please choose",
    hungarian: "Kérlek válassz",
    serbian: "Изаберите",
    spanish: "Por favor, elige",
    french: "Veuillez choisir",
    german: "Bitte wählen",
    chinese: "请选择",
    russian: "Пожалуйста, выберите",
    arabic: "يرجى الاختيار",
    portuguese: "Por favor, escolha",
    ukrainian: "Будь ласка, виберіть",
    hindi: "कृपया चुनें",
    japanese: "選択してください"
  },
  congrats: {
    english: "Congratulations, you are very clever! :)",
    hungarian: "Gratulálok, nagyon ügyes vagy! :)",
    serbian: "Честитамо, веома си вешт!",
    spanish: "¡Felicidades, eres muy inteligente! :)",
    french: "Félicitations, vous êtes très intelligent ! :)",
    german: "Herzlichen Glückwunsch, du bist sehr klug! :)",
    chinese: "恭喜，你很聪明！:)",
    russian: "Поздравляем, вы очень умны! :)",
    arabic: "مبروك، أنت ذكي جدًا! :)",
    portuguese: "Parabéns, você é muito inteligente! :)",
    ukrainian: "Вітаємо, ви дуже розумні! :)",
    hindi: "बधाई हो, आप बहुत होशियार हैं! :)",
    japanese: "おめでとう、とても賢いですね！ :)"
  },
  motivate_next: {
    english: "I'm motivated, next!",
    hungarian: "Motivált vagyok, tovább!",
    serbian: "Мотивисан сам, даље!",
    spanish: "Estoy motivado, ¡siguiente!",
    french: "Je suis motivé, suivant !",
    german: "Ich bin motiviert, weiter!",
    chinese: "我很有动力，继续！",
    russian: "Я мотивирован, дальше!",
    arabic: "أنا متحمس، التالي!",
    portuguese: "Estou motivado, próximo!",
    ukrainian: "Я мотивований, далі!",
    hindi: "मैं प्रेरित हूँ, आगे!",
    japanese: "やる気満々、次へ！"
  },
  display_name: {
    english: "Name",
    hungarian: "Név",
    serbian: "Име",
    spanish: "Nombre",
    french: "Nom",
    german: "Name",
    chinese: "姓名",
    russian: "Имя",
    arabic: "الاسم",
    portuguese: "Nome",
    ukrainian: "Ім'я",
    hindi: "नाम",
    japanese: "名前"
  },
  points: {
    english: "points",
    hungarian: "pont",
    serbian: "поена",
    spanish: "puntos",
    french: "points",
    german: "Punkte",
    chinese: "分数",
    russian: "баллы",
    arabic: "نقاط",
    portuguese: "pontos",
    ukrainian: "бали",
    hindi: "अंक",
    japanese: "ポイント"
  },
  your_score: {
    english: "Your score in",
    hungarian: "Pontszámod ebben:",
    serbian: "Ваш резултат за",
    spanish: "Tu puntuación en",
    french: "Votre score dans",
    german: "Dein Punktestand in",
    chinese: "你的分数在",
    russian: "Ваш счет в",
    arabic: "درجتك في",
    portuguese: "Sua pontuação em",
    ukrainian: "Ваш рахунок у",
    hindi: "आपका स्कोर",
    japanese: "あなたのスコア"
  },
  subscribe: {
    english: "Subscribe for full access",
    hungarian: "Előfizetés teljes hozzáféréshez",
    serbian: "Претплатите се за потпуни приступ",
    spanish: "Suscríbete para acceso completo",
    french: "Abonnez-vous pour un accès complet",
    german: "Abonnieren für vollen Zugriff",
    chinese: "订阅以获得完整访问权限",
    russian: "Подпишитесь для полного доступа",
    arabic: "اشترك للوصول الكامل",
    portuguese: "Assine para acesso total",
    ukrainian: "Підпишіться для повного доступу",
    hindi: "पूर्ण पहुँच के लिए सदस्यता लें",
    japanese: "全アクセスのために購読"
  },
  donate: {
    english: "Donate",
    hungarian: "Adományozz",
    serbian: "Донирај",
    spanish: "Donar",
    french: "Faire un don",
    german: "Spenden",
    chinese: "捐赠",
    russian: "Пожертвовать",
    arabic: "تبرع",
    portuguese: "Doar",
    ukrainian: "Пожертвувати",
    hindi: "दान करें",
    japanese: "寄付する"
  }
};

// --- Stripe donation linkek ---
const STRIPE_DONATION_LINK_1 = "https://donate.stripe.com/14AbJ32tEfWJcaa656gw000";
const STRIPE_DONATION_LINK_2 = "https://buy.stripe.com/aFa7sNgku5i52zAgJKgw001";
const STRIPE_DONATION_LINK_3 = "https://buy.stripe.com/14AdRb5FQ4e11vw3WYgw002";

// --- Segédfüggvény ---
function shuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function App() {
  const [user, setUser] = useState(null);
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [registerForm, setRegisterForm] = useState({ email: "", password: "" });
  const [authError, setAuthError] = useState("");
  const [mode, setMode] = useState("login");
  const [page, setPage] = useState(() => localStorage.getItem("page") || "mainmenu");

const [fromLang, setFromLang] = useState(() => localStorage.getItem("fromLang") || "english");
const [toLang, setToLang] = useState(() => localStorage.getItem("toLang") || "hungarian");

  const [premiumOpen, setPremiumOpen] = useState(false);


  const [chapters, setChapters] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(() => {
  const saved = localStorage.getItem("selectedChapter");
  return saved ? JSON.parse(saved) : null;
});
  const [words, setWords] = useState([]);
  const [currentWordIdx, setCurrentWordIdx] = useState(0);

  const [dropped, setDropped] = useState([]);
  const [choices, setChoices] = useState([]);
  const [testError, setTestError] = useState("");
  const [testFinished, setTestFinished] = useState(false);

  const [chapterProgress, setChapterProgress] = useState({});
  const [score, setScore] = useState(0);

const [uiLang, setUiLang] = useState(() => localStorage.getItem("uiLang") || "hungarian");  const [uiWords, setUiWords] = useState(defaultUiWords);

  const [displayName, setDisplayName] = useState("");
  const [askDisplayName, setAskDisplayName] = useState(false);
  const [pendingDisplayName, setPendingDisplayName] = useState("");

  const [isPremiumUser, setIsPremiumUser] = useState(false);

  const [chapterAlert, setChapterAlert] = useState(""); // ÚJ: alert szöveg

  


  const audioRef = useRef();

  // Stripe Customer Portal megnyitása
  async function openCustomerPortal(userId) {
    const res = await fetch('https://nyelvtanuloappbackend.onrender.com/create-customer-portal-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId })
    });
    const data = await res.json();
    if (data.url) {
      window.location.href = data.url;
    } else {
      alert('Nem sikerült megnyitni a Stripe Customer Portal-t.');
    }
  }

// App.js elején, az useState-ek mellé:
const [isLandscape, setIsLandscape] = useState(false);

useEffect(() => {
  function handleOrientationChange() {
    setIsLandscape(window.innerWidth > window.innerHeight);
  }
  handleOrientationChange(); // kezdeti érték
  window.addEventListener("resize", handleOrientationChange);
  window.addEventListener("orientationchange", handleOrientationChange);
  return () => {
    window.removeEventListener("resize", handleOrientationChange);
    window.removeEventListener("orientationchange", handleOrientationChange);
  };
}, []);

  // Display name bekérés, ha még nincs név
  useEffect(() => {
    async function fetchDisplayName() {
      if (user) {
        const { data } = await supabase
          .from("profiles")
          .select("display_name")
          .eq("id", user.id)
          .maybeSingle();
        if (!data?.display_name) {
          setAskDisplayName(true);
          setDisplayName("");
        } else {
          setDisplayName(data.display_name);
          setAskDisplayName(false);
        }
      } else {
        setDisplayName("");
        setAskDisplayName(false);
      }
    }
    fetchDisplayName();
  }, [user]);

  // Pontszám lekérdezése az aktuális nyelvpárhoz
  useEffect(() => {
    async function fetchScore() {
      if (!user) return setScore(0);
      const { data } = await supabase
        .from("user_scores")
        .select("score")
        .eq("user_id", user.id)
        .eq("from_lang", fromLang)
        .eq("to_lang", toLang)
        .maybeSingle();
      setScore(data?.score || 0);
    }
    fetchScore();
  }, [user, fromLang, toLang, testFinished]);

useEffect(() => {
  localStorage.setItem("uiLang", uiLang);
}, [uiLang]);


useEffect(() => {
  localStorage.setItem("fromLang", fromLang);
}, [fromLang]);

useEffect(() => {
  localStorage.setItem("toLang", toLang);
}, [toLang]);

  useEffect(() => {
    async function fetchUiWords() {
      const { data } = await supabase.from("ui_words").select("*");
      if (data && data.length > 0) {
        const dict = {};
        data.forEach(row => {
          dict[row.key] = row;
        });
        setUiWords(dict);
      }
    }
    fetchUiWords();
  }, []);

  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) {
        setMode("main");
      } else {
        setMode("login");
      }
    });
    supabase.auth.getUser().then(({ data }) => {
      setUser(data?.user ?? null);
      if (data?.user) {
        setMode("main");
      }
    });
    return () => listener?.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    async function fetchChapters() {
      const { data } = await supabase.from("chapters").select("*").order("id");
      setChapters(data || []);
    }
    if (user && page === "chapters") fetchChapters();
  }, [user, page]);

  useEffect(() => {
    async function fetchWords(chapterId) {
      const { data } = await supabase
        .from("words")
        .select("*")
        .eq("chapter_id", chapterId)
        .order("id");
      setWords(data || []);
    }
    if (selectedChapter && (page === "learn" || page === "test")) fetchWords(selectedChapter.id);
    else setWords([]);
  }, [selectedChapter, page]);

  useEffect(() => {
  if (user && page === "learn" && selectedChapter && words.length > 0) {
    destroyAudio();
    const word = words[currentWordIdx];
    playPronunciation(word[toLang], toLang);
  }
  // eslint-disable-next-line
}, [currentWordIdx]);

  useEffect(() => {
    if (page === "learn" && words.length > 0) {
      setCurrentWordIdx(0);
    }
    if (page === "test" && words.length > 0) {
      setDropped(Array(words.length).fill(null));
      setChoices(shuffle(words.map(w => w[toLang])));
      setTestError("");
      setTestFinished(false);
    }
  }, [page, words, fromLang, toLang]);

 // Ha dropped tömb nincs inicializálva, inicializáld
  useEffect(() => {
    if (!dropped || dropped.length !== words.length) {
      setDropped(Array(words.length).fill(null));
      setChoices(shuffle(words.map(w => w[toLang])));
      setTestError("");
      setTestFinished(false);
    }
    // eslint-disable-next-line
  }, [words]);


  
 useEffect(() => {
  let ignore = false;
  async function fetchProgress() {
    if (!user) return;
    const { data } = await supabase
      .from("progress")
      .select("*")
      .eq("user_id", user.id)
      .eq("from_lang", fromLang)
      .eq("to_lang", toLang)
      .eq("unlocked", true); // <-- EZT JAVÍTSD: completed helyett unlocked
    if (ignore) return;
    const progressMap = {};
    (data || []).forEach(row => {
      progressMap[row.chapter_id] = row.completed; // completed: true/false
    });
    setChapterProgress(progressMap);
  }
  fetchProgress();
  return () => { ignore = true; };
}, [user, fromLang, toLang, page, testFinished]);

  useEffect(() => {
    let ignore = false;
    async function fetchTestProgress() {
      if (!user || !selectedChapter || !fromLang || !toLang) return;
      const { data } = await supabase
        .from("progress")
        .select("*")
        .eq("user_id", user.id)
        .eq("chapter_id", selectedChapter.id)
        .eq("from_lang", fromLang)
        .eq("to_lang", toLang)
        .eq("completed", true)
        .maybeSingle();
      if (!ignore && data) setTestFinished(true);
    }
    fetchTestProgress();
    return () => { ignore = true; };
  }, [user, selectedChapter, fromLang, toLang]);

  const baseUrl = "https://axfkablwysnukojhymip.supabase.co/storage/v1/object/public/audio/";

 function normalizeAudioFilename(str) {
  const map = {
    'đ': 'dj', 'Đ': 'Dj',
    'č': 'c',  'Č': 'C',
    'ć': 'c',  'Ć': 'C',
    'š': 's',  'Š': 'S',
    'ž': 'z',  'Ž': 'Z'
  };
  let s = str.replace(/[đĐčČćĆšŠžŽ]/g, m => map[m]);
  s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  s = s.replace(/[^\w\s]/gi, "");
  s = s.replace(/\s+/g, " ").trim();
  return s;
}

const langMap = {
  english: "en",
  hungarian: "hu",
  german: "de",
  serbian: "sr",
  spanish: "es",
  french: "fr",
  japanese: "ja",
  korean: "ko",
  italian: "it",
  hindi: "hi",
  chinese: "zh",
  portuguese: "pt",
  arabic: "ar",
  bengali: "bn",
  russian: "ru",
  punjabi: "pa",
  javanese: "jv",
  vietnamese: "vi",
  tamil: "ta",
  urdu: "ur",
  turkish: "tr",
  persian: "fa",
  polish: "pl",
  dutch: "nl",
  ukrainian: "uk",
  romanian: "ro",
  greek: "el",
  czech: "cs",
  swedish: "sv",
  bulgarian: "bg",
  danish: "da",
  finnish: "fi",
  slovak: "sk",
  hebrew: "he",
  thai: "th",
  croatian: "hr",
  lithuanian: "lt",
  latvian: "lv",
  estonian: "et",
  icelandic: "is",
  malay: "ms",
  burmese: "my",
  nepali: "ne",
  khmer: "km",
  lao: "lo",
  sinhala: "si",
  amharic: "am",
  swahili: "sw",
  hausa: "ha",
  yoruba: "yo"
};

function destroyAudio() {
  if (audioRef.current) {
    try {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.src = "";
      audioRef.current.removeAttribute("src");
      audioRef.current.load();
    } catch {}
    audioRef.current = null;
  }
}

function playPronunciation(text, langKey) {
  destroyAudio(); // Mindig először állítsd le az előzőt!

  const langFolder = langMap[langKey] || langKey;
  const filename = normalizeAudioFilename(text) + ".mp3";
  const url = `${baseUrl}${langFolder}/${filename}`;

  fetch(url, { method: "HEAD" })
    .then(response => {
      if (response.ok) {
        const audio = new window.Audio(url);
        audioRef.current = audio;
        audio.play().catch(() => {});
      }
    });
}

useEffect(() => {
  async function fetchPremiumStatus() {
    if (!user) {
      setIsPremiumUser(false);
      return;
    }
    const { data } = await supabase
      .from("profiles")
            .select("is_language_subscriber") // <-- ÚJ MEZŐ

      .eq("id", user.id)
      .maybeSingle();
        setIsPremiumUser(!!data?.is_language_subscriber); // <-- ÚJ MEZŐ

  }
  fetchPremiumStatus();
}, [user, page]); // <-- page-t is figyeli!

  

  const handleLogin = async (e) => {
    e.preventDefault();
    setAuthError("");
    const { error } = await supabase.auth.signInWithPassword({
      email: loginForm.email,
      password: loginForm.password,
    });
    if (error) setAuthError(error.message);
  };


  const handleRegister = async (e) => {
    e.preventDefault();
    setAuthError("");
    const { error } = await supabase.auth.signUp({
      email: registerForm.email,
      password: registerForm.password,
    });
    if (error) setAuthError(error.message);
    else {
      alert(uiWords.registration_success?.[uiLang] || defaultUiWords.registration_success[uiLang]);
      setMode("login");
    }
  };

  const handleDisplayNameSubmit = async (e) => {
    e.preventDefault();
    if (!pendingDisplayName) return;
    const { error } = await supabase
      .from("profiles")
      .upsert([{ id: user.id, display_name: pendingDisplayName }]);
    if (!error) {
      setDisplayName(pendingDisplayName);
      setAskDisplayName(false);
    } else {
      setAuthError("Profile save error: " + error.message);
    }
  };

 const handleLogout = async () => {
  await supabase.auth.signOut();
  setUser(null);
  setSelectedChapter(null);
  setWords([]);
  setMode("login");
  localStorage.removeItem("page"); // <-- törli a mentett oldalt
  localStorage.removeItem("selectedChapter"); // törlés

  setPage("mainmenu");
};

  function setPageAndSave(newPage) {
  setPage(newPage);
  localStorage.setItem("page", newPage);
}

  const t = (key) => uiWords[key]?.[uiLang] || defaultUiWords[key]?.[uiLang] || key;

  // --- STYLES ---
  const style = (
  <style>{`
    ${isLandscape ? `
      body, #root {
        background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%) !important;
        overflow: hidden;
      }
        @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateY(-30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
         .center-card {
        animation: slideIn 0.5s ease-out, fadeIn 0.5s ease-out;
      }
      .chapter-btn {
        animation: glow 1.5s infinite alternate, fadeIn 0.3s ease-out;
      }
      .main-bg {
        background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%) !important;
        min-height: 100vh;
      }
      .center-card {
        background: rgba(20, 25, 45, 0.85) !important;
        border: 2px solid #ffcc00 !important;
        box-shadow: 0 0 30px rgba(255, 204, 0, 0.4), 0 8px 32px rgba(0, 0, 0, 0.6) !important;
        border-radius: 24px !important;
        backdrop-filter: blur(10px);
      }
      .main-title {
        color: #ffcc00 !important;
        text-shadow: 0 0 20px rgba(255, 204, 0, 0.8), 0 4px 8px rgba(0, 0, 0, 0.8);
        font-weight: 900 !important;
        letter-spacing: 2px !important;
      }
      .next-btn, .chapter-btn {
        background: linear-gradient(90deg, #ff4081 0%, #ff6b35 100%) !important;
        box-shadow: 0 0 20px rgba(255, 64, 129, 0.6), 0 4px 12px rgba(0, 0, 0, 0.4) !important;
        border: 2px solid #ff4081 !important;
        color: #fff !important;
        font-weight: 800 !important;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
        animation: glow 1.5s infinite alternate;
      }
      @keyframes glow {
        from { box-shadow: 0 0 20px rgba(255, 64, 129, 0.6), 0 4px 12px rgba(0, 0, 0, 0.4); }
        to { box-shadow: 0 0 40px rgba(255, 107, 53, 0.9), 0 6px 18px rgba(0, 0, 0, 0.6); }
      }
      .back-btn {
        background: rgba(30, 35, 55, 0.8) !important;
        border: 2px solid #4f8cff !important;
        color: #4f8cff !important;
        font-weight: 700 !important;
        box-shadow: 0 0 15px rgba(79, 140, 255, 0.4);
      }
      .user-bar, nav {
        background: linear-gradient(90deg, #0a0e27 0%, #1a1f3a 100%) !important;
        border-bottom: 2px solid #ffcc00 !important;
        box-shadow: 0 4px 20px rgba(255, 204, 0, 0.3);
      }
      .input-field {
        background: rgba(30, 35, 55, 0.9) !important;
        border: 2px solid #4f8cff !important;
        color: #fff !important;
        box-shadow: 0 0 10px rgba(79, 140, 255, 0.3);
      }
      .word-to {
        color: #ffcc00 !important;
        text-shadow: 0 0 10px rgba(255, 204, 0, 0.6);
      }
    ` : ''}

    body, #root {
      height: 100vh;
      min-height: 100vh;
      margin: 0;
      padding: 0;
      
      background: #f5f6fa;
    }
    .main-bg {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6fa;
}
    .center-card {
      background: #fff;
      border-radius: 32px;
      box-shadow: 0 8px 32px rgba(44,62,80,0.12);
      padding: 48px 36px 36px 36px;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 320px;
      max-width: 95vw;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .main-title {
      font-size: 2.1rem;
      font-weight: 700;
      margin: 0 0 32px 0;
      text-align: center;
      color: #2d3a4a;
    }
    .chapters-list {
      list-style: none;
      padding: 0;
      margin: 0 0 32px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 18px;
      justify-content: center;
    }
    .chapter-btn {
      font-size: 1.2rem;
      font-weight: 600;
      background: linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%);
      color: #fff;
      border: none;
      border-radius: 20px;
      padding: 12px 36px;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(44,62,80,0.07);
      transition: background 0.2s, transform 0.2s;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      min-width: 120px;
      max-width: 100vw;
      white-space: nowrap;
    }
    .chapter-btn[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
      background: #e3f0fc;
      color: #bcd;
    }
    .chapter-btn:hover:enabled {
      background: linear-gradient(90deg, #4f8cff 0%, #43e0fc 100%);
      transform: translateY(-2px) scale(1.03);
      color: #fff;
    }
    .input-field {
      font-size: 1.1rem;
      border-radius: 14px;
      border: 1px solid #bcd;
      background: #e3f0fc;
      color: #2d3a4a;
      padding: 10px 18px;
      font-weight: 500;
      outline: none;
      margin-bottom: 14px;
      width: 100%;
      box-sizing: border-box;
    }
    .next-btn, .back-btn {
      font-size: 1.15rem;
      font-weight: 700;
      border-radius: 20px;
      padding: 12px 0;
      background: linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%);
      color: #fff;
      border: none;
      box-shadow: 0 2px 8px rgba(44,62,80,0.07);
      cursor: pointer;
      margin-bottom: 0;
      transition: background 0.2s, transform 0.2s;
      width: 100%;
      margin-top: 10px;
    }
    .back-btn {
      background: #e3f0fc;
      color: #2d3a4a;
      font-weight: 600;
      box-shadow: none;
      border: none;
      margin-top: 18px;
    }
    .next-btn:hover:enabled, .back-btn:hover:enabled {
      background: linear-gradient(90deg, #4f8cff 0%, #43e0fc 100%);
      color: #fff;
      transform: translateY(-2px) scale(1.03);
    }
    .test-error {
      color: #ff5e62;
      font-weight: 600;
      margin-top: 12px;
      text-align: center;
    }
    .ui-lang-dropdown, .lang-dropdown {
      font-size: 1.15rem;
      border-radius: 16px;
      border: none;
      background: #e3f0fc;
      color: #2d3a4a;
      padding: 10px 28px 10px 16px;
      box-shadow: 0 2px 8px rgba(44,62,80,0.07);
      outline: none;
      min-width: 140px;
      font-weight: 500;
      text-align: center;
      appearance: none;
      WebkitAppearance: none;
      MozAppearance: none;
    }
    .word-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 24px;
    }
    .word-from {
      font-size: 1.25rem;
      font-weight: 700;
      color: #2d3a4a;
      margin-bottom: 8px;
    }
    .word-to {
      font-size: 1.25rem;
      font-weight: 600;
      color: #4f8cff;
      cursor: pointer;
      margin-bottom: 8px;
    }
    .test-score {
      font-size: 1.4rem;
      font-weight: 800;
      color: #2d3a4a;
      margin: 32px 0 16px 0;
      text-align: center;
    }
    .user-bar, nav {
      width: 100vw;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-height: 54px;
      background: #fff;
      border-bottom: 1px solid #222;
      position: sticky;
      top: 0;
      z-index: 100;
      overflow-x: auto;
      WebkitOverflowScrolling: touch;
      padding: 0;
      margin: 0;
    }
    .user-bar ul, nav ul {
      display: flex;
      gap: 18px;
      padding: 0 12px;
      margin: 0;
      list-style: none;
      align-items: center;
      min-width: max-content;
    }
    .user-bar li, nav li {
      display: flex;
      align-items: center;
      min-width: 0;
    }
    @media (max-width: 600px) {
  .center-card {
    padding: 12px 0 12px 0 !important;
    min-width: unset !important;
    max-width: 100vw !important;
    border-radius: 14px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  .main-title {
    font-size: 1.3rem;
    margin-bottom: 18px;
  }
      .chapters-list {
        gap: 10px;
      }
      .chapter-btn {
        font-size: 1rem;
        padding: 10px 10px;
        min-width: 90px;
        border-radius: 14px;
      }
      nav, .user-bar {
        min-height: 44px !important;
        font-size: 0.98rem !important;
        padding: 0;
      }
      .user-bar ul, nav ul {
        gap: 8px !important;
        padding: 0 6px;
      }
      .user-bar li, nav li {
        min-width: 0 !important;
      }
      .input-field {
        font-size: 1rem;
        padding: 8px 12px;
        border-radius: 10px;
      }
      .next-btn, .back-btn {
        font-size: 1rem;
        border-radius: 14px;
        padding: 10px 0;
      }
      .test-score {
        font-size: 1.1rem;
        margin: 18px 0 10px 0;
      }
      .word-from, .word-to {
        font-size: 1.05rem;
      }
    }
  `}</style>
);

  // Ajándékdoboz ikon
  function GiftBoxIcon({ size = 28, color = "#4f8cff" }) {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
        <rect x="8" y="18" width="32" height="22" rx="6" fill="#fff" stroke={color} strokeWidth="2"/>
        <rect x="8" y="18" width="32" height="8" rx="2" fill="#e3f0fc"/>
        <rect x="22" y="18" width="4" height="22" fill={color}/>
        <path d="M24 18c-6-7-12-10-12-13 0-3 4-3 6 0 2 3 6 13 6 13z" fill="#89f7fe" stroke={color} strokeWidth="2"/>
        <path d="M24 18c6-7 12-10 12-13 0-3-4-3-6 0-2 3-6 13-6 13z" fill="#66a6ff" stroke={color} strokeWidth="2"/>
      </svg>
    );
  }

function AppFooter() {
  const [termsOpen, setTermsOpen] = useState(false);
  return (
    <>
      <footer style={{
        marginTop: 32,
        textAlign: "center",
        color: "#7a8ca3",
        fontSize: "1rem",
        fontWeight: 500
      }}>
        <div style={{ marginBottom: 8 }}>
          <a href="https://facebook.com/dringocean" target="_blank" rel="noopener noreferrer" style={{ margin: "0 12px", verticalAlign: "middle" }}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" style={{ width: 24, height: 24, verticalAlign: "middle" }} />
          </a>
          <a href="https://twitter.com/dringocean80712" target="_blank" rel="noopener noreferrer" style={{ margin: "0 12px", verticalAlign: "middle" }}>
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6f/Logo_of_Twitter.svg" alt="X (Twitter)" style={{ width: 24, height: 24, verticalAlign: "middle" }} />
          </a>
   <a href="https://tiktok.com/@dringocean" target="_blank" rel="noopener noreferrer" style={{ margin: "0 12px", verticalAlign: "middle" }}>
  <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/tiktok.svg" alt="TikTok" style={{ width: 24, height: 24, verticalAlign: "middle", background: "#fff", borderRadius: "6px" }} />
</a>
<a href="https://youtube.com/@Dringocean" target="_blank" rel="noopener noreferrer" style={{ margin: "0 12px", verticalAlign: "middle" }}>
  <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 24, height: 24, verticalAlign: "middle", borderRadius: "6px", background: "#fff" }} />
</a>
        </div>
        © Dringocean. All rights reserved.{" "}
        <button
          style={{
            background: "none",
            border: "none",
            color: "#4f8cff",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "1rem",
            fontWeight: 600,
            marginLeft: 8
          }}
          onClick={() => setTermsOpen(true)}
        >
          Felhasználási feltételek
        </button>
      </footer>
      <TermsModal open={termsOpen} onClose={() => setTermsOpen(false)} />
    </>
  );
}

  // Prémium előfizetés modal
  function PremiumModal({ open, onClose, onSubscribe, onCancelSubscription }) {
    if (!open) return null;
    const PRICES = [
      { priceId: "price_1S2dVvPw4LvplVlSfRaHuPKs", label: "100 EUR / Day" },
      { priceId: "price_1S4pDEPw4LvplVlSRZEsvoxw", label: "11 EUR / Month" },
      { priceId: "price_1S3irCPw4LvplVlSM3RmSQ3v", label: "250 EUR / Year" }
    ];
    const boxColors = ["#66a6ff", "#89f7fe", "#4f8cff"];
    const DONATIONS = [
      { url: STRIPE_DONATION_LINK_1, label: "100 EUR" },
      { url: STRIPE_DONATION_LINK_2, label: "250 EUR" },
      { url: STRIPE_DONATION_LINK_3, label: "1000 EUR" }
    ];
    return (
      <div style={{
        position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
        background: "rgba(44,62,80,0.18)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <div style={{
          background: "#fff", borderRadius: 28, padding: 36, minWidth: 320, boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
          display: "flex", flexDirection: "column", alignItems: "center", position: "relative"
        }}>
          <button onClick={onClose} style={{
            position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#4f8cff"
          }}>×</button>
          <div style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: 18, color: "#2d3a4a" }}>
            🎁 Prémium előfizetés
          </div>
          <div style={{ display: "flex", gap: 24, marginBottom: 18 }}>
            {PRICES.map((p, i) => (
              <button
                key={p.priceId}
                onClick={() => onSubscribe(p.priceId)}
                style={{
                  background: boxColors[i],
                  border: "none",
                  borderRadius: 18,
                  boxShadow: "0 4px 18px rgba(44,62,80,0.13)",
                  padding: "18px 18px 12px 18px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "transform 0.15s",
                  minWidth: 80
                }}
              >
                <GiftBoxIcon size={38} color="#fff" />
                <span style={{
                  marginTop: 8,
                  fontWeight: 700,
                  color: "#fff",
                  fontSize: "1.1rem",
                  textShadow: "0 2px 8px #2d3a4a33"
                }}>
                  {p.label}
                </span>
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: 24, marginBottom: 10 }}>
            {DONATIONS.map((d, i) => (
              <a
                key={i}
                href={d.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  background: "linear-gradient(90deg, #e3f0fc 0%, #d0e6fa 100%)",
                  color: "#2d3a4a",
                  fontWeight: 700,
                  fontSize: "1.08rem",
                  borderRadius: 18,
                  padding: "14px 18px 10px 18px",
                  textDecoration: "none",
                  boxShadow: "0 4px 18px rgba(44,62,80,0.10)",
                  minWidth: 80,
                  border: "2px solid #66a6ff",
                  transition: "transform 0.13s, box-shadow 0.13s",
                }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = "scale(1.06)";
                  e.currentTarget.style.boxShadow = "0 6px 24px rgba(44,62,80,0.18)";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "0 4px 18px rgba(44,62,80,0.10)";
                }}
              >
                <svg width="32" height="32" viewBox="0 0 48 48" fill="none" style={{marginBottom: 4}}>
                  <rect x="8" y="18" width="32" height="22" rx="6" fill="#fff" stroke="#4f8cff" strokeWidth="2"/>
                  <rect x="8" y="18" width="32" height="8" rx="2" fill="#e3f0fc"/>
                  <rect x="22" y="18" width="4" height="22" fill="#4f8cff"/>
                  <path d="M24 18c-6-7-12-10-12-13 0-3 4-3 6 0 2 3 6 13 6 13z" fill="#89f7fe" stroke="#4f8cff" strokeWidth="2"/>
                  <path d="M24 18c6-7 12-10 12-13 0-3-4-3-6 0-2 3-6 13-6 13z" fill="#66a6ff" stroke="#4f8cff" strokeWidth="2"/>
                </svg>
                <span style={{
                  fontWeight: 700,
                  color: "#2d3a4a",
                  fontSize: "1.08rem",
                  marginTop: 2,
                  letterSpacing: "-0.5px"
                }}>
                  Donation {d.label}
                </span>
              </a>
            ))}
          </div>
          <div style={{ color: "#7a8ca3", fontSize: "1rem", marginTop: 8, textAlign: "center" }}>
            Subscribe or support! Thank you! 
          </div>
          <button
            onClick={onCancelSubscription}
            style={{
              marginTop: 28,
              background: "#e3f0fc",
              color: "#2d3a4a",
              fontWeight: 600,
              fontSize: "0.98rem",
              borderRadius: 16,
              padding: "8px 18px",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
              opacity: 0.85
            }}
          >
            Előfizetés lemondása
          </button>
        </div>
      </div>
    );
  }

// --- USER BAR komponens --
function UserBar({ onBack, page }) {
  const [premiumOpen, setPremiumOpen] = React.useState(false);
  const showPremium = ["languages", "chapters", "learn", "test"].includes(page);

  // Delfin szimbólum (Dringocean arculathoz illő)
  function DolphinIcon({ size = 38 }) {
    return (
      <svg width={size} height={size} viewBox="0 0 60 60" fill="none">
        <ellipse cx="30" cy="38" rx="20" ry="17" fill="#e3f0fc"/>
        <path d="M13 44 Q16 28 30 23 Q44 18 47 39 Q44 33 36 33 Q33 41 26 44 Q21 46 13 44 Z"
          fill="#4f8cff" stroke="#2d3a4a" strokeWidth="2"/>
        <ellipse cx="41" cy="31" rx="1.7" ry="2.2" fill="#fff"/>
        <ellipse cx="41" cy="31" rx="0.9" ry="1.1" fill="#2d3a4a"/>
        <ellipse cx="47" cy="39" rx="3" ry="1.7" fill="#66a6ff" opacity="0.7"/>
        <ellipse cx="19" cy="44" rx="3" ry="1.7" fill="#66a6ff" opacity="0.7"/>
        <path d="M47 39 Q52 40 56 36 Q52 38 49 34" stroke="#4f8cff" strokeWidth="1.5" fill="none"/>
        <ellipse cx="30" cy="52" rx="3.5" ry="1.5" fill="#89f7fe" opacity="0.7"/>
      </svg>
    );
  }

  // Menü gomb stílus
  const isMobile = window.innerWidth <= 600;
  const menuBtnStyle = {
    background: "none",
    border: "none",
    outline: "none",
    color: "#2d3a4a",
    fontWeight: 600,
    fontSize: isMobile ? "0.98rem" : "1.08rem",
    padding: isMobile ? "0 8px" : "0 14px",
    height: isMobile ? 38 : 44,
    cursor: "pointer",
    borderRadius: isMobile ? 6 : 8,
    transition: "background 0.15s, color 0.15s",
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    boxSizing: "border-box"
  };

  // Vissza gomb
  function BackButton() {
    const handleBack = () => {
      if (onBack) onBack();
      else window.history.back();
    };
    return (
      <button
        onClick={handleBack}
        style={{
          ...menuBtnStyle,
          color: "#2d3a4a",
          fontWeight: 700,
          background: "none",
          border: "none",
          borderRadius: isMobile ? 6 : 8,
          padding: isMobile ? "0 8px" : "0 14px",
          gap: 6,
        }}
        onMouseOver={e => (e.currentTarget.style.background = "#f5f6fa")}
        onMouseOut={e => (e.currentTarget.style.background = "none")}
      >
        <svg width="20" height="20" style={{ verticalAlign: "middle", marginRight: 4 }} fill="none" stroke="#4f8cff" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
        {t("back")}
      </button>
    );
  }

  // Kék nyíl a nyelvválasztóhoz
  function DropdownArrow() {
    return (
      <svg width="18" height="18" style={{ display: "block" }} viewBox="0 0 24 24" fill="none">
        <path d="M7 10l5 5 5-5" stroke="#4f8cff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }


  return (
    <div
    style={{
      width: "100%",
      left: 0,
      right: 0,
      top: 0,
      position: "sticky",
      zIndex: 100,
      background: "#fff",
      borderBottom: "1px solid #222",
      minHeight: isMobile ? 44 : 54,
      boxSizing: "border-box",
      overflowX: "auto",
      margin: 0,
      padding: 0,
      display: "flex",
      alignItems: "center",
      //justifyContent: "center"
    }}
  >
    <ul
      style={{
        display: "flex",
        gap: isMobile ? 8 : 18,
        padding: isMobile ? "0 6px" : "0 12px",
        margin: 0,
        listStyle: "none",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minWidth: "max-content", // <-- EZ FONTOS!
        boxSizing: "border-box"
      }}
    >
        {/* Szia, User! + ajándékdoboz */}
        <li>
          <button
            style={{
              ...menuBtnStyle,
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              gap: 8,
              background: "none"
            }}
            tabIndex={0}
            onClick={() => setPremiumOpen(true)}
            onMouseOver={e => (e.currentTarget.style.background = "#f5f6fa")}
            onMouseOut={e => (e.currentTarget.style.background = "none")}
            title="Prémium előfizetés"
          >
            <li>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: isLandscape ? "linear-gradient(90deg, #ff4081, #ff6b35)" : "none",
              borderRadius: isLandscape ? 20 : 0,
              padding: isLandscape ? "8px 16px" : "0",
              boxShadow: isLandscape ? "0 0 20px rgba(255, 64, 129, 0.6)" : "none"
            }}>
              {/* Avatar kép */}
              <div style={{
                width: isLandscape ? 42 : 32,
                height: isLandscape ? 42 : 32,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #ffcc00, #ff6b35)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 900,
                fontSize: isLandscape ? "1.2rem" : "1rem",
                color: "#fff",
                textShadow: "0 2px 8px rgba(0,0,0,0.8)",
                border: isLandscape ? "3px solid #ffcc00" : "2px solid #4f8cff",
                boxShadow: isLandscape ? "0 0 20px rgba(255, 204, 0, 0.8)" : "none"
              }}>
                {displayName ? displayName[0].toUpperCase() : "U"}
              </div>
              <span style={{
                fontWeight: 700,
                color: isLandscape ? "#fff" : "#2d3a4a",
                textShadow: isLandscape ? "0 2px 8px rgba(0,0,0,0.8)" : "none"
              }}>
                {displayName || user?.email}
              </span>
            </div>
          </li>
            {showPremium && <GiftBoxIcon size={isMobile ? 18 : 22} />}
          </button>
          <PremiumModal
            open={premiumOpen}
            onClose={() => setPremiumOpen(false)}
            onSubscribe={async (priceId) => {
              if (!user) {
                alert("Előbb jelentkezz be!");
                return;
              }
              try {
                const response = await fetch('https://nyelvtanuloappbackend.onrender.com/create-checkout-session', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    userId: user.id,
                    priceId: priceId
                  })
                });
                const data = await response.json();
                if (data.url) {
                  window.location.href = data.url;
                } else {
                  alert('Nem sikerült elindítani a fizetést.');
                }
              } catch (e) {
                alert('Hiba történt a fizetés indításakor.');
              }
            }}
            onCancelSubscription={() => openCustomerPortal(user.id)}
          />
        </li>
        {/* Pontszám + delfin */}
        <li>
          <span
            style={{
              ...menuBtnStyle,
              fontWeight: 700,
              color: "#2d3a4a",
              cursor: "default",
              pointerEvents: "none",
              fontSize: isMobile ? "1rem" : "1.18rem",
              gap: 10,
              background: "none"
            }}
          >
            {score}
            <DolphinIcon size={isMobile ? 28 : 38} />
          </span>
        </li>
        {/* Vissza gomb */}
        <li>
          <BackButton />
        </li>
        {/* Nyelvválasztó */}
        <li style={{ position: "relative" }}>
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <select
              className="ui-lang-dropdown"
              value={uiLang}
              onChange={e => setUiLang(e.target.value)}
              aria-label="UI language"
              style={{
                ...menuBtnStyle,
                padding: isMobile ? "0 24px 0 8px" : "0 34px 0 14px",
                minWidth: isMobile ? 70 : 90,
                fontWeight: 500,
                cursor: "pointer",
                background: "none",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
              }}
              onMouseOver={e => (e.currentTarget.style.background = "#f5f6fa")}
              onMouseOut={e => (e.currentTarget.style.background = "none")}
            >
              {UI_LANGS.map(l => (
                <option key={l.key} value={l.key}>{l.label}</option>
              ))}
            </select>
            <span style={{
              pointerEvents: "none",
              position: "absolute",
              right: isMobile ? 6 : 10,
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}>
              <DropdownArrow />
            </span>
          </div>
        </li>
        {/* Kijelentkezés */}
        <li>
          <button
            onClick={handleLogout}
            style={{
              ...menuBtnStyle,
              fontWeight: 700,
              color: "#2d3a4a",
              marginLeft: 2,
            }}
            onMouseOver={e => (e.currentTarget.style.background = "#f5f6fa")}
            onMouseOut={e => (e.currentTarget.style.background = "none")}
          >
            {t("logout")}
          </button>
        </li>
      </ul>
    </div>
  );
}

  // --- FŐMENÜ ---
function MainMenu({ onSelect }) {
  const isDev = user?.email === "iw2bpln@gmail.com";
  const menuItems = isDev
    ? [
        { key: "mainmenu", label: "Főmenü", onClick: () => onSelect("mainmenu") },
        { key: "magnet-order", label: "Mágnes", onClick: () => onSelect("magnet-order") },
        { key: "languages", label: "Nyelvválasztó", onClick: () => onSelect("languages") },
        { key: "chapters", label: "Fejezetek", onClick: () => onSelect("chapters") },
        { key: "ai-tutorial", label: "AI Tananyag", onClick: () => onSelect("ai-tutorial") },
        { key: "about", label: "Névjegy", onClick: () => onSelect("about") },
      ]
    : [
        { key: "mainmenu", label: "Főmenü", onClick: () => onSelect("mainmenu") },
        { key: "magnet-order", label: "Mágnes", onClick: () => onSelect("magnet-order") },
        { key: "languages", label: "Nyelvválasztó", onClick: () => onSelect("languages") },
      ];

  return (
    <div className="main-bg" style={{minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between"}}>
      <TopNavBar items={menuItems} active={"mainmenu"} />
      {style}
      <div className="center-card" style={{
        animation: isLandscape ? "slideIn 0.5s ease-out" : "none",
        padding: isLandscape ? "28px 48px" : "44px 36px",
        minWidth: isLandscape ? 380 : 320,
        maxWidth: isLandscape ? 480 : 380,
        margin: "auto",
        borderRadius: isLandscape ? 24 : 32,
        boxSizing: "border-box",
        textAlign: "center"
      }}>
        <h1 className="main-title" style={{
          marginBottom: 32,
          fontSize: "2.1rem",
          fontWeight: 800,
          letterSpacing: "-1px",
          color: isLandscape ? "#ffcc00" : "#2d3a4a"
        }}>
          Main Menu
        </h1>
        <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 16}}>
          <button
            className="next-btn"
            style={{
              width: "100%",
              borderRadius: 20,
              padding: "14px 28px",
              fontSize: "1.15rem",
              cursor: "pointer",
            }}
            onClick={() => onSelect("language-learning")}
          >
            Language Learning
          </button>
          <button
            className="next-btn"
            style={{
              width: "100%",
              background: isLandscape
                ? "linear-gradient(90deg, #ff9900 0%, #ff5500 100%)"
                : "linear-gradient(90deg, #ff9900 0%, #ff5500 100%)",
              border: isLandscape ? "2px solid #ff9900" : "none",
              boxShadow: isLandscape
                ? "0 0 20px rgba(255, 153, 0, 0.6), 0 4px 12px rgba(0, 0, 0, 0.4)"
                : "0 4px 14px rgba(255,153,0,0.35)",
              color: "#fff",
              fontWeight: 800,
              borderRadius: 20,
              padding: "14px 28px",
              fontSize: "1.15rem",
              cursor: "pointer",
            }}
            onClick={() => onSelect("magnet-order")}
          >
            🧲 Order Mágnes
          </button>
          {isDev && (
            <>
              <button className="next-btn" style={{width: "100%"}} onClick={() => onSelect("ai-tutorial")}>
                AI Tutorial
              </button>
              <button className="next-btn" style={{width: "100%"}}>.. Learning</button>
              <button className="next-btn" style={{width: "100%"}}>.. Learning</button>
            </>
          )}
        </div>
      </div>
      <AppFooter />
    </div>
  );
}

  // Display name bekérő oldal
  if (user && askDisplayName) {
    return (
      <div className="main-bg" style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
        {style}
        <div className="center-card" style={{padding: 48, minWidth: 340, maxWidth: 420, margin: "auto"}}>
          <h1 className="main-title">{t("display_name")}</h1>
          <form
            onSubmit={handleDisplayNameSubmit}
            style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}
          >
            <input
              className="input-field"
              placeholder={t("display_name")}
              type="text"
              value={pendingDisplayName}
              onChange={e => setPendingDisplayName(e.target.value)}
              required
              autoFocus
            />
            <button className="next-btn" type="submit" style={{width: "100%", marginTop: 10}}>
              {t("continue")}
            </button>
          </form>
          {authError && <div className="test-error" style={{marginTop: 12}}>{authError}</div>}
        </div>
      </div>
    );
  }

// ...existing code...
// Login/Register UI
if (!user && (mode === "register" || mode === "login")) {
  const isLogin = mode === "login";
  return (
    <div className="main-bg" style={{minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "center", background: "#fff"}}>
      {style}
      {/* Felső sáv: bal oldalon Dringocean logó, jobb oldalon nyelvválasztó */}
      <nav
        style={{
          borderBottom: "1px solid #222",
          background: "#fff",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: 56,
          padding: "0 0",
        }}
      >
        {/* Bal oldal: Dringocean logó */}
        <div style={{ minWidth: 180, display: "flex", alignItems: "center", paddingLeft: 24 }}>
          <a
            href="https://dringocean.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#4f8cff"
            }}
          >
            <img
              src={EMPTY_LOGO_URL}
              alt="Dringocean"
              style={{ height: 38, marginRight: 10, borderRadius: 8, background: "#e3f0fc" }}
            />
            <span style={{ fontWeight: 800, fontSize: "1.15rem", letterSpacing: "-1px" }}>Dringocean</span>
          </a>
        </div>
        {/* Közép: üres */}
        <div style={{ flex: 1 }} />
        {/* Jobb oldal: nyelvválasztó */}
        <div style={{ minWidth: 180, display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: 24 }}>
          <select
            className="ui-lang-dropdown"
            value={uiLang}
            onChange={e => setUiLang(e.target.value)}
            aria-label="UI language"
          >
            {UI_LANGS.map(l => (
              <option key={l.key} value={l.key}>{l.label}</option>
            ))}
          </select>
        </div>
      </nav>
       {/* Kártya */}
      <div className="center-card" style={{
        padding: "48px 36px 36px 36px",
        minWidth: 350,
        maxWidth: 400,
        margin: "auto",
        boxShadow: "0 8px 32px rgba(44,62,80,0.15)",
        borderRadius: 32,
        border: "1px solid #222", // <-- 3px fekete körvonal
        boxSizing: "border-box"      // <-- hogy a körvonal ne lógjon ki
      }}>
        {/* Félkövér Dringocean felirat */}
        <h1 className="main-title" style={{
          fontSize: "2.1rem",
          fontWeight: 1000, // <-- félkövér
          margin: "0 0 32px 0",
          textAlign: "center",
          color: "#2d3a4a"
        }}>
          Dringocean
        </h1>
        <form
          onSubmit={isLogin ? handleLogin : handleRegister}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <input
            className="input-field"
            placeholder={t("email")}
            type="email"
            value={isLogin ? loginForm.email : registerForm.email}
            onChange={e =>
              isLogin
                ? setLoginForm({ ...loginForm, email: e.target.value })
                : setRegisterForm({ ...registerForm, email: e.target.value })
            }
            autoFocus={isLogin}
            required
            style={{
              textAlign: "center"
            }}
          />
          <input
            className="input-field"
            type="password"
            placeholder={t("password")}
            value={isLogin ? loginForm.password : registerForm.password}
            onChange={e =>
              isLogin
                ? setLoginForm({ ...loginForm, password: e.target.value })
                : setRegisterForm({ ...registerForm, password: e.target.value })
            }
            required
            style={{
              textAlign: "center"
            }}
          />
          <button className="next-btn" type="submit" style={{
            width: "100%",
            marginTop: 10,
            fontSize: "1.15rem",
            fontWeight: 700,
            borderRadius: 20,
            padding: "12px 0",
            background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
            color: "#fff",
            border: "none",
            boxShadow: "0 2px 8px rgba(44,62,80,0.07)"
          }}>
            {isLogin ? t("login") : t("register")}
          </button>
        </form>
        {authError && <div className="test-error" style={{marginTop: 12}}>{authError}</div>}
        <button
          className="back-btn"
          style={{
            marginTop: 22,
            width: "100%",
            justifyContent: "center",
            fontSize: "1.05rem",
            borderRadius: 20,
            padding: "10px 0"
          }}
          onClick={() => setMode(isLogin ? "register" : "login")}
        >
          {isLogin ? t("register") : t("already_have_account")}
        </button>
      </div>
  <AppFooter />
    </div>
  );
}
// ...existing code...

  // FŐMENÜ
  if (user && page === "mainmenu") {
    return (
      <MainMenu
        onSelect={option => {
          if (option === "language-learning") {
            setPageAndSave("languages");
          }
          if (option === "ai-tutorial") {
            setPageAndSave("ai-tutorial");
          }
          if (option === "magnet-order") {
            setPageAndSave("magnet-order");
          }
        }}
      />
    );
  }

  // MÁGNES RENDELŐ OLDAL (63.5 x 63.5 mm)
  if (user && page === "magnet-order") {
    return <MagnetOrder onBack={() => setPageAndSave("mainmenu")} user={user} isLandscape={isLandscape} />;
  }

  // ...existing code...vvdfv

if (user && page === "about") {
  return <AboutDringocean onBack={() => setPageAndSave("mainmenu")} />;
}


// ...existing code...

// App komponens belsejében, a return ágak között:
if (user && page === "ai-tutorial") {
  return <AITutorial onBack={() => setPageAndSave("mainmenu")} />;
}

// --- NYELVVÁLASZTÓ OLDAL ---
if (user && page === "languages") {
  const handleSwapLanguages = () => {
    setFromLang(toLang);
    setToLang(fromLang);
  };

  const handleBack = () => setPageAndSave("mainmenu");

  const langDropdownStyle = {
    fontSize: "1.15rem",
    borderRadius: 16,
    border: "none",
    background: "#e3f0fc",
    color: "#2d3a4a",
    padding: "10px 28px 10px 16px",
    boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
    outline: "none",
    minWidth: 140,
    fontWeight: 500,
    textAlign: "center",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none"
  };

  const langDropdownExtraStyle = (
    <style>{`
      select.lang-dropdown {
        max-height: calc(2.4em * 7);
        overflow-y: auto;
      }
    `}</style>
  );

  return (
    <>
      {langDropdownExtraStyle}
      
       <UserBar onBack={handleBack} page={page} />
      
      <div className="main-bg" style={{
  minHeight: "100vh",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "#f5f6fa"
}}>
        {style}
        <div className="center-card"
          style={{
            padding: 48,
            minWidth: 340,
            maxWidth: 420,
            margin: "auto",
            borderRadius: 32,
            boxShadow: "0 8px 32px rgba(44,62,80,0.10)",
            background: "#fff",
            border: "1px solid #222",
            boxSizing: "border-box"
          }}
        >
          <h1
            className="main-title"
            style={{
              marginBottom: 36,
              fontSize: "2.1rem",
              fontWeight: 800,
              letterSpacing: "-1px",
              color: "#2d3a4a",
            }}
          >
            {t("pick_your_wish")}
          </h1>
          <div
            className="lang-select-row"
            style={{
              marginBottom: 28,
              display: "flex",
              alignItems: "center",
              gap: 18,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <label
              className="lang-label"
              style={{
                fontSize: "1.25rem",
                fontWeight: 500,
                color: "#2d3a4a",
                textAlign: "center",
              }}
            >
              {t("source_language")}:
            </label>
            <select
              className="lang-dropdown"
              value={fromLang}
              onChange={e => setFromLang(e.target.value)}
              style={langDropdownStyle}
            >
              {LANGS.filter(l => l.key !== toLang).map(l => (
                <option key={l.key} value={l.key}>
                  {l.label[uiLang] || l.label.english}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="lang-dropdown"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                minWidth: 48,
                padding: "10px 16px",
                border: "none",
                outline: "none",
                background: "#e3f0fc",
              }}
              onClick={handleSwapLanguages}
              title="Nyelvek felcserélése"
            >
              <svg width="22" height="22" fill="none" stroke="#2d3a4a" strokeWidth="3" viewBox="0 0 24 24">
                <line x1="6" y1="9" x2="18" y2="9" />
                <line x1="6" y1="15" x2="18" y2="15" />
              </svg>
            </button>
          </div>
          <div
            className="lang-select-row"
            style={{
              marginBottom: 32,
              display: "flex",
              alignItems: "center",
              gap: 18,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <label
              className="lang-label"
              style={{
                fontSize: "1.25rem",
                fontWeight: 500,
                color: "#2d3a4a",
                textAlign: "center",
              }}
            >
              {t("target_language")}:
            </label>
            <select
              className="lang-dropdown"
              value={toLang}
              onChange={e => setToLang(e.target.value)}
              style={langDropdownStyle}
            >
              {LANGS.filter(l => l.key !== fromLang).map(l => (
                <option key={l.key} value={l.key}>
                  {l.label[uiLang] || l.label.english}
                </option>
              ))}
            </select>
          </div>
          <button
            className="next-btn"
            style={{
              width: "100%",
              fontSize: "1.15rem",
              fontWeight: 700,
              borderRadius: 20,
              padding: "12px 0",
              background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
              color: "#fff",
              border: "none",
              boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
            }}
            onClick={() => setPageAndSave("chapters")}
          >
            {t("continue")}
          </button>
        </div>
      <AppFooter />
      </div>
    </>
  );
}

// --- CHAPTERS OLDAL ---
if (user && page === "chapters") {
  const sortedChapters = [...chapters].sort((a, b) => a.id - b.id);

  // Fejezet elérhetőség logika
  const isChapterUnlocked = (idx) => {
    if (idx === 0) return true;
    const prevChapter = sortedChapters[idx - 1];
    return (
      chapterProgress[prevChapter.id] === true && // előző fejezet completed
      isPremiumUser // van előfizetés
    );
  };

  const handleBack = () => {
    setSelectedChapter(null);
    localStorage.removeItem("selectedChapter");
    setPageAndSave("languages");
  };

  return (
    <>
      <UserBar onBack={handleBack} page={page} />
      <div className="main-bg" style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#f5f6fa"
      }}>
        {style}
        <div className="center-card" style={{
          padding: 48,
          minWidth: 340,
          maxWidth: 480,
          margin: "48px auto 0 auto",
          borderRadius: 32,
          boxShadow: "0 8px 32px rgba(44,62,80,0.10)",
          background: "#fff",
          border: "1px solid #222",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}>
          <h1 className="main-title" style={{
            marginBottom: 36,
            fontSize: "2.1rem",
            fontWeight: 800,
            letterSpacing: "-1px",
            color: "#2d3a4a",
            textAlign: "center"
          }}>
            {t("select_chapter")}
          </h1>
          <ul className="chapters-list">
            {sortedChapters.map((chap, idx) => {
              const unlocked = isChapterUnlocked(idx);
              const completed = chapterProgress[chap.id] === true;
              const isCurrent = selectedChapter && chap.id === selectedChapter.id;
              return (
                <li key={chap.id}>
                  <button
                    className="chapter-btn"
                    onClick={() => {
                      if (unlocked) {
                        setSelectedChapter(chap);
                        localStorage.setItem("selectedChapter", JSON.stringify(chap));
                        setPageAndSave("learn");
                        setChapterAlert("");
                      } else if (idx !== 0 && !isPremiumUser) {
                        setChapterAlert("Ehhez a fejezethez előfizetés szükséges!");
                      } else {
                        setChapterAlert("");
                      }
                    }}
                    disabled={!unlocked}
                    style={{
                      background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
                      color: "#fff",
                      opacity: unlocked ? 1 : 0.7,
                      position: "relative",
                      border: isCurrent ? "3px solid #000" : "none",
                      fontWeight: isCurrent ? 800 : 600,
                      letterSpacing: isCurrent ? "-0.5px" : "normal",
                      transform: isCurrent ? "scale(1.04)" : "none",
                      zIndex: isCurrent ? 2 : 1,
                      boxShadow: isCurrent
                        ? "0 0 0 3px #2d6cff44, 0 4px 18px rgba(44,62,80,0.13)"
                        : "0 2px 8px rgba(44,62,80,0.07)",
                      minWidth: 120,
                      maxWidth: "100vw",
                      borderRadius: 20,
                      padding: "12px 36px",
                      marginBottom: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span style={{
                      display: "inline-block",
                      minWidth: 28,
                      fontWeight: 700,
                      color: "#fff",
                      marginRight: 8
                    }}>
                      {idx + 1}.
                    </span>
                    {chap[fromLang] || chap.english || chap.hungarian || chap.serbian}
                    {completed && (
                      <svg width="18" height="18" style={{marginLeft: 8, verticalAlign: "middle"}} fill="none" stroke="#fff" strokeWidth="3" viewBox="0 0 24 24">
                        <path d="M5 13l4 4L19 7"/>
                      </svg>
                    )}
                    {!unlocked && (
                      <svg width="18" height="18" style={{marginLeft: 8, verticalAlign: "middle"}} fill="none" stroke="#fff" strokeWidth="2" viewBox="0 0 24 24">
                        <rect x="5" y="11" width="14" height="8" rx="2" stroke="#fff" strokeWidth="2" fill="none"/>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="#fff" strokeWidth="2" fill="none"/>
                      </svg>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
          {chapterAlert && (
            <div style={{ color: "#ff5e62", fontWeight: 600, marginBottom: 12, textAlign: "center" }}>
              {chapterAlert}
            </div>
          )}
          <button className="back-btn" style={{width: "100%"}} onClick={handleBack}>
            <svg width="22" height="22" style={{ verticalAlign: "middle", marginRight: 8 }} fill="none" stroke="#2d3a4a" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
            {t("back_to_languages")}
          </button>
        </div>
        <AppFooter />
      </div>
    </>
  );
}

// --- TANULÁS OLDAL ---
if (user && page === "learn" && selectedChapter && words.length > 0) {
  const word = words[currentWordIdx];

  const handleBack = () => {
    setSelectedChapter(null);
    localStorage.removeItem("selectedChapter");
    setPageAndSave("chapters");
    destroyAudio(); // audio leállítása visszalépéskor
  };

  // Next szó gomb
 const handleNext = () => {
  destroyAudio();
  setCurrentWordIdx(idx => idx + 1);
};

const handlePrev = () => {
  destroyAudio();
  setCurrentWordIdx(idx => idx - 1);
};

  // Szóra kattintáskor
  const handlePlay = () => {
    destroyAudio();
    playPronunciation(word[toLang], toLang);
  };

  return (
    <>
      <UserBar onBack={handleBack} page={page} />
      <div className="main-bg" style={{ minHeight: "100vh", background: "#f5f6fa" }}>
        {style}
        <div className="center-card learn-content" style={{
          padding: 48,
          minWidth: 340,
          maxWidth: 480,
          margin: "48px auto 0 auto",
          borderRadius: 32,
          boxShadow: "0 8px 32px rgba(44,62,80,0.10)",
          background: "#fff",
          border: "1px solid #222",
          boxSizing: "border-box"
        }}>
          <div className="word-card">
            <div className="word-from">
              {word[fromLang]}
            </div>
            <div
              className="word-to"
              style={{ cursor: "pointer" }}
              title="Kiejtés meghallgatása"
              onClick={handlePlay}
            >
              {word[toLang]}
              <svg style={{marginLeft: 8, verticalAlign: "middle"}} width="24" height="24" fill="#4f8cff" viewBox="0 0 24 24">
                <path d="M3 10v4h4l5 5V5l-5 5H3zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.06c1.48-.74 2.5-2.26 2.5-4.03z"/>
              </svg>
            </div>
          </div>
          <div style={{ marginTop: 32 }}>
            {currentWordIdx > 0 && (
              <button className="back-btn" style={{marginRight: 16}} onClick={handlePrev}>
                {t("previous")}
              </button>
            )}
            {currentWordIdx < words.length - 1 && (
              <button className="next-btn" onClick={handleNext}>
                {t("next")}
              </button>
            )}
            {currentWordIdx === words.length - 1 && (
              <button className="next-btn" onClick={() => {
                destroyAudio();
                setPageAndSave("test");
              }}>
                {t("start_test")}
              </button>
            )}
          </div>
          <button className="back-btn" style={{marginTop: 24}} onClick={handleBack}>
            <svg width="22" height="22" style={{ verticalAlign: "middle", marginRight: 8 }} fill="none" stroke="#2d3a4a" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
            {t("back_to_chapters")}
          </button>
        </div>
        <AppFooter />
      </div>
    </>
  );
}

// --- TESZT OLDAL ---
if (user && page === "test" && selectedChapter) {

  if (!words || words.length === 0) {
    return (
      <div className="main-bg" style={{ minHeight: "100vh", background: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="center-card" style={{ padding: 48, minWidth: 340, maxWidth: 420 }}>
          <h1 className="main-title">Betöltés...</h1>
        </div>
      </div>
    );
  }

  const allFilled = dropped && dropped.length === words.length && dropped.every(d => d !== null);
  const showResult = testFinished && allFilled;
  const isSuccess = showResult && words.every((w, idx) => dropped[idx] === w[toLang]);

  const handleDrop = (idx, value) => {
    const newDropped = [...dropped];
    newDropped[idx] = value;
    setDropped(newDropped);
    setTestError("");
  };

  const handleSubmit = async () => {
    console.log("handleSubmit lefutott", { fromLang, toLang, selectedChapter });

    if (!allFilled) {
      setTestError(t("test_fill_all"));
      return;
    }
    const correct = words.every((w, idx) => dropped[idx] === w[toLang]);
    if (!correct) {
      setTestError(t("test_perfect"));
      setTestFinished(true);
      return;
    }
    setTestError("");
    setTestFinished(true);

    const sortedChapters = [...chapters].sort((a, b) => a.id - b.id);
    const chapterIndex = sortedChapters.findIndex(ch => ch.id === selectedChapter.id);

    // Aktuális fejezetet completed-nek jelöljük
    await supabase.from("progress").upsert([{
      user_id: user.id,
      chapter_index: chapterIndex,
      chapter_id: selectedChapter.id,
      from_lang: fromLang,
      to_lang: toLang,
      completed: true,
      unlocked: true
    }], { onConflict: "user_id,from_lang,to_lang,chapter_id" });

    setChapterProgress(prev => ({ ...prev, [selectedChapter.id]: true }));

    // Csak a következő fejezetet unlockold, ha van előfizetés és az előző 100% completed
    const nextChapter = sortedChapters[chapterIndex + 1];
    if (nextChapter && isPremiumUser) {
      await supabase.from("progress").upsert([{
        user_id: user.id,
        chapter_index: chapterIndex + 1,
        chapter_id: nextChapter.id,
        from_lang: fromLang,
        to_lang: toLang,
        completed: false,
        unlocked: true
      }], { onConflict: "user_id,from_lang,to_lang,chapter_id" });
      setChapterProgress(prev => ({ ...prev, [nextChapter.id]: false }));
    }

    // Pontszám frissítése
    const { data: scoreRow } = await supabase
      .from("user_scores")
      .select("score")
      .eq("user_id", user.id)
      .eq("from_lang", fromLang)
      .eq("to_lang", toLang)
      .maybeSingle();

    const newScore = (scoreRow?.score || 0) + 10;

    await supabase
      .from("user_scores")
      .upsert([{
        user_id: user.id,
        from_lang: fromLang,
        to_lang: toLang,
        score: newScore
      }], { onConflict: "user_id,from_lang,to_lang" });
  };

  const handleTryAgain = () => {
    setDropped(Array(words.length).fill(null));
    setChoices(shuffle(words.map(w => w[toLang])));
    setTestError("");
    setTestFinished(false);
  };

  const sortedChapters = [...chapters].sort((a, b) => a.id - b.id);
  const currentChapterIdx = sortedChapters.findIndex(ch => ch.id === selectedChapter.id);
  const nextChapter = sortedChapters[currentChapterIdx + 1];

  const handleNextChapter = () => {
    if (nextChapter) {
      setSelectedChapter(nextChapter);
      localStorage.setItem("selectedChapter", JSON.stringify(nextChapter));
      setPageAndSave("learn");
    } else {
      setSelectedChapter(null);
      localStorage.removeItem("selectedChapter");
      setPageAndSave("chapters");
    }
  };

  const handleBack = () => {
    setSelectedChapter(null);
    localStorage.removeItem("selectedChapter");
    setPageAndSave("chapters");
  };

  return (
    <>
          <UserBar onBack={handleBack} page={page} />
      <div className="main-bg" style={{ minHeight: "100vh", background: "#f5f6fa" }}>
        {style}
        <div className="center-card" style={{
          padding: 48,
          minWidth: 340,
          maxWidth: 540,
          margin: "48px auto 0 auto",
          borderRadius: 32,
          boxShadow: "0 8px 32px rgba(44,62,80,0.10)",
          background: "#fff",
          border: "1px solid #222",
          boxSizing: "border-box"
        }}>
          {!showResult ? (
            <>
              <h1 className="main-title">{t("test")}</h1>
              <div style={{marginBottom: 24}}>
                {words.map((w, idx) => (
                  <div key={idx} style={{display: "flex", alignItems: "center", marginBottom: 14}}>
                    <div style={{
                      minWidth: 120,
                      fontWeight: 600,
                      fontSize: "1.15rem",
                      color: "#2d3a4a",
                      marginRight: 18
                    }}>
                      {w[fromLang]}
                    </div>
                    <select
                      style={{
                        fontSize: "1.1rem",
                        borderRadius: 14,
                        border: "none",
                        background: "#e3f0fc",
                        color: "#2d3a4a",
                        padding: "8px 18px 8px 12px",
                        fontWeight: 500,
                        outline: "none",
                        minWidth: 120
                      }}
                      value={dropped[idx] || ""}
                      onChange={e => handleDrop(idx, e.target.value)}
                      disabled={showResult}
                    >
                      <option value="" disabled>{t("please_choose")}</option>
                      {choices.map((choice, cidx) => (
                        <option key={cidx} value={choice}>{choice}</option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>
              {testError && <div className="test-error">{testError}</div>}
              <button
                className="next-btn"
                style={{width: "100%", marginTop: 18}}
                onClick={handleSubmit}
                disabled={!allFilled}
              >
                {t("submit")}
              </button>
              <button className="back-btn" style={{marginTop: 24}} onClick={handleBack}>
                <svg width="22" height="22" style={{ verticalAlign: "middle", marginRight: 8 }} fill="none" stroke="#2d3a4a" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
                {t("back_to_chapters")}
              </button>
            </>
          ) : isSuccess ? (
            <>
              <div style={{display: "flex", flexDirection: "column", alignItems: "center", margin: "32px 0 16px 0"}}>
                <div style={{
                  width: 220,
                  height: 220,
                  borderRadius: "50%",
                  background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 24,
                  boxShadow: "0 4px 24px rgba(44,62,80,0.13)"
                }}>
                  <svg width="140" height="140" viewBox="0 0 64 64" fill="none">
                    <path d="M18 34l13 13 15-21" stroke="#fff" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={{
                  fontSize: "1.4rem",
                  fontWeight: 800,
                  color: "#2d3a4a",
                  marginBottom: 8,
                  textAlign: "center"
                }}>
                  {t("congrats")}
                </div>
              </div>
              <button
                className="next-btn"
                style={{
                  width: "100%",
                  marginTop: 18,
                  fontSize: "1.15rem",
                  fontWeight: 700,
                  borderRadius: 20,
                  padding: "14px 0",
                  background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
                  color: "#fff",
                  border: "none",
                  boxShadow: "0 2px 8px rgba(44,62,80,0.07)"
                }}
                onClick={() => {
                  if (isPremiumUser) {
                    handleNextChapter();
                  } else {
                    alert("Ehhez a funkcióhoz előfizetés szükséges!");
                  }
                }}
                disabled={!isPremiumUser}
              >
                {t("motivate_next")}
              </button>
              {!isPremiumUser && (
                <>
                  <div style={{ color: "#ff5e62", fontWeight: 600, marginTop: 12, textAlign: "center" }}>
                    Előfizetés szükséges a továbblépéshez!
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                    <button
                      onClick={() => setPremiumOpen(true)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        marginLeft: 0,
                        display: "inline-flex",
                        alignItems: "center",
                        height: 44,
                        fontSize: "1.18rem"
                      }}
                      title="Prémium előfizetés"
                    >
                      <GiftBoxIcon size={38} />
                      <span style={{
                        fontWeight: 700,
                        color: "#4f8cff",
                        marginLeft: 12,
                        fontSize: "1.18rem"
                      }}>
                        Prémium előfizetés
                      </span>
                    </button>
                  </div>
                  <PremiumModal
                    open={premiumOpen}
                    onClose={() => setPremiumOpen(false)}
                    onSubscribe={async (priceId) => {
                      if (!user) {
                        alert("Előbb jelentkezz be!");
                        return;
                      }
                      try {
                        const response = await fetch('https://nyelvtanuloappbackend.onrender.com/create-checkout-session', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                            userId: user.id,
                            priceId: priceId
                          })
                        });
                        const data = await response.json();
                        if (data.url) {
                          window.location.href = data.url;
                        } else {
                          alert('Nem sikerült elindítani a fizetést.');
                        }
                      } catch (e) {
                        alert('Hiba történt a fizetés indításakor.');
                      }
                    }}
                    onCancelSubscription={() => openCustomerPortal(user.id)}
                  />
                </>
              )}
            </>
          ) : (
            <>
              <h1 className="main-title">{t("test")}</h1>
              <div className="test-score" style={{
                fontSize: "1.4rem",
                fontWeight: 800,
                color: "#2d3a4a",
                margin: "32px 0 16px 0",
                textAlign: "center"
              }}>
                {testFinished && allFilled
                  ? `${words.filter((w, idx) => dropped[idx] === w[toLang]).length} / ${words.length}`
                  : ""}
              </div>
              <button className="next-btn" style={{width: "100%", marginTop: 18}} onClick={handleTryAgain}>
                {t("try_again")}
              </button>
              <button className="back-btn" style={{marginTop: 24}} onClick={handleBack}>
                <svg width="22" height="22" style={{ verticalAlign: "middle", marginRight: 8 }} fill="none" stroke="#2d3a4a" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
                {t("back_to_chapters")}
              </button>
              {/* Piros szöveg + előfizetés gomb */}
              <div style={{ color: "#ff5e62", fontWeight: 600, marginTop: 24, marginBottom: 12, textAlign: "center" }}>
                Előfizetés szükséges a továbblépéshez!
              </div>
              <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                <button
                  onClick={() => setPremiumOpen(true)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    marginLeft: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    height: 44,
                    fontSize: "1.18rem"
                  }}
                  title="Prémium előfizetés"
                >
                  <GiftBoxIcon size={38} />
                  <span style={{
                    fontWeight: 700,
                    color: "#4f8cff",
                    marginLeft: 12,
                    fontSize: "1.18rem"
                  }}>
                    Prémium előfizetés
                  </span>
                </button>
              </div>
              <PremiumModal
                open={premiumOpen}
                onClose={() => setPremiumOpen(false)}
                onSubscribe={async (priceId) => {
                  if (!user) {
                    alert("Előbb jelentkezz be!");
                    return;
                  }
                  try {
                    const response = await fetch('https://nyelvtanuloappbackend.onrender.com/create-checkout-session', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        userId: user.id,
                        priceId: priceId
                      })
                    });
                    const data = await response.json();
                    if (data.url) {
                      window.location.href = data.url;
                    } else {
                      alert('Nem sikerült elindítani a fizetést.');
                    }
                  } catch (e) {
                    alert('Hiba történt a fizetés indításakor.');
                  }
                }}
                onCancelSubscription={() => openCustomerPortal(user.id)}
              />
            </>
          )}
        </div>
        <footer style={{
          marginTop: 32,
          textAlign: "center",
          color: "#7a8ca3",
          fontSize: "1rem",
          fontWeight: 500
        }}>
          © Dringocean. All rights reserved.
        </footer>
      </div>
    </>
  );
}}

// ...existing code...
function AITutorial({ onBack }) {
  // Tananyag szintek és leckék
  const curriculum = [
    {
      level: "Mini AI (5-7 éveseknek)",
      lessons: [
        {
          title: "Mi az, hogy AI?",
          content: (
            <>
              <p>
                Az AI, vagyis mesterséges intelligencia, olyan számítógép, ami tud gondolkodni, tanulni és segíteni nekünk. Például: robot, okostelefon, beszélő játék.
              </p>
              <ul>
                <li><b>Példa:</b> Egy robot, ami tud beszélni vagy táncolni.</li>
                <li><b>Példa:</b> Okostelefon, ami felismeri az arcodat.</li>
              </ul>
            </>
          ),
        },
        {
          title: "AI a mindennapokban",
          content: (
            <>
              <p>
                Az AI felismeri a képeket, beszél hozzánk, segít a játékokban.
              </p>
              <ul>
                <li>Képes játék: <i>Találd ki, mit lát a robot!</i></li>
              </ul>
            </>
          ),
        },
      ],
    },
    {
      level: "AI Junior (8-12 éveseknek)",
      lessons: [
        {
          title: "Hogyan tanul egy AI?",
          content: (
            <>
              <p>
                Az AI sok képet, hangot vagy szöveget néz meg, és megtanulja felismerni, mi van rajta.
              </p>
              <ul>
                <li>Példa: Kutya felismerése képről.</li>
              </ul>
            </>
          ),
        },
        {
          title: "Egyszerű gépi tanulás",
          content: (
            <>
              <p>
                Az AI kategóriákba sorolja a dolgokat: színek, formák, állatok.
              </p>
              <ul>
                <li>Interaktív játék: <i>Tanítsd meg a robotot felismerni a cicát!</i></li>
              </ul>
            </>
          ),
        },
      ],
    },
    {
      level: "AI Explorer (13-16 éveseknek)",
      lessons: [
        {
          title: "Adatok és minták",
          content: (
            <>
              <p>
                Az AI adatokból tanul. Az adat lehet kép, szöveg, szám, bármi. Az AI mintákat keres ezekben.
              </p>
              <ul>
                <li>Példa: E-mailek közül kiválasztani a spamet.</li>
              </ul>
            </>
          ),
        },
        {
          title: "Neurális hálók alapjai",
          content: (
            <>
              <p>
                A neurális háló olyan, mint egy egyszerű agy: sok kis egység dolgozik együtt, hogy felismerje a mintákat.
              </p>
              <ul>
                <li>Képes magyarázat: “Agyháló” rajz.</li>
              </ul>
            </>
          ),
        },
        {
          title: "Kódolás: Egyszerű AI Pythonban",
          content: (
            <>
              <p>
                Próbáld ki, hogyan lehet egy AI-t programozni! (Vizuális blokkos kód, pl. Scratch vagy egyszerű Python példa)
              </p>
              <pre style={{background: "#e3f0fc", padding: 10, borderRadius: 8}}>
{`példa:
from sklearn import tree
clf = tree.DecisionTreeClassifier()
clf = clf.fit([[0, 0], [1, 1]], [0, 1])
print(clf.predict([[2., 2.]]))`}
              </pre>
            </>
          ),
        },
      ],
    },
    {
      level: "AI Pro (17+)",
      premium: true,
      lessons: [
        {
          title: "Mélytanulás, neurális hálók",
          content: (
            <>
              <p>
                A mélytanulás (deep learning) többrétegű neurális hálókat használ, amelyek képesek nagyon összetett mintákat is felismerni.
              </p>
              <ul>
                <li>Képletek, rétegek, példák.</li>
              </ul>
            </>
          ),
        },
        {
          title: "Képfeldolgozás, szövegfeldolgozás",
          content: (
            <>
              <p>
                Az AI képes képeket, szövegeket, hangokat feldolgozni és értelmezni.
              </p>
              <ul>
                <li>Példa: Saját AI modell tanítása (Python, TensorFlow).</li>
              </ul>
              <pre style={{background: "#e3f0fc", padding: 10, borderRadius: 8}}>
{`import tensorflow as tf
model = tf.keras.Sequential([
  tf.keras.layers.Dense(10, activation='relu'),
  tf.keras.layers.Dense(1)
])`}
              </pre>
            </>
          ),
        },
      ],
    },
    {
      level: "AI Master",
      premium: true,
      lessons: [
        {
          title: "Etika, veszélyek, jövő",
          content: (
            <>
              <p>
                Az AI használatának vannak etikai kérdései: adatvédelem, torzítás, felelősség.
              </p>
              <ul>
                <li>AI a tudományban, művészetben.</li>
              </ul>
            </>
          ),
        },
        {
          title: "Projekt: Saját AI alkalmazás készítése",
          content: (
            <>
              <p>
                Próbálj meg egy egyszerű AI alkalmazást készíteni! (Pl. képfelismerő, chatbot, játék)
              </p>
            </>
          ),
        },
      ],
    },
  ];

  // Állapot: aktuális szint és lecke
  const [levelIdx, setLevelIdx] = React.useState(0);
  const [lessonIdx, setLessonIdx] = React.useState(0);

  // Prémium szintek kezelése (itt most mindenki láthatja, de ide teheted a jogosultságot)
  const isPremium = curriculum[levelIdx]?.premium;

  // Aktuális szint és lecke
  const level = curriculum[levelIdx];
  const lesson = level.lessons[lessonIdx];

  // Navigáció
  function prevLesson() {
    if (lessonIdx > 0) setLessonIdx(lessonIdx - 1);
    else if (levelIdx > 0) {
      setLevelIdx(levelIdx - 1);
      setLessonIdx(curriculum[levelIdx - 1].lessons.length - 1);
    }
  }
  function nextLesson() {
    if (lessonIdx < level.lessons.length - 1) setLessonIdx(lessonIdx + 1);
    else if (levelIdx < curriculum.length - 1) {
      setLevelIdx(levelIdx + 1);
      setLessonIdx(0);
    }
  }
  function selectLevel(idx) {
    setLevelIdx(idx);
    setLessonIdx(0);
  }

  return (
    <div className="main-bg" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="center-card" style={{ padding: 32, minWidth: 340, maxWidth: 900, margin: "auto", display: "flex", flexDirection: "row", gap: 32 }}>
        {/* Bal oldali sáv: szintek */}
        <div style={{ minWidth: 180 }}>
          <h3 style={{ marginBottom: 16, color: "#4f8cff" }}>Szintek</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {curriculum.map((lvl, idx) => (
              <li key={lvl.level} style={{ marginBottom: 8 }}>
                <button
                  onClick={() => selectLevel(idx)}
                  style={{
                    background: idx === levelIdx ? "#4f8cff" : "#e3f0fc",
                    color: idx === levelIdx ? "#fff" : "#2d3a4a",
                    fontWeight: idx === levelIdx ? 700 : 500,
                    border: "none",
                    borderRadius: 12,
                    padding: "8px 14px",
                    width: "100%",
                    cursor: "pointer",
                    marginBottom: 2,
                  }}
                >
                  {lvl.level} {lvl.premium && <span style={{fontSize: 12, color: "#ff5e62"}}>★</span>}
                </button>
              </li>
            ))}
          </ul>
        </div>
        {/* Fő tartalom */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ marginBottom: 8, color: "#7a8ca3", fontWeight: 600 }}>
            {level.level} {isPremium && <span style={{color: "#ff5e62"}}> (Prémium)</span>}
          </div>
          <h2 className="main-title" style={{ margin: "0 0 18px 0", fontSize: "1.5rem" }}>{lesson.title}</h2>
          <div style={{ fontSize: "1.13rem", color: "#2d3a4a", lineHeight: 1.7, marginBottom: 18 }}>
            {lesson.content}
          </div>
          <div style={{ display: "flex", gap: 12, marginTop: 18 }}>
            <button className="back-btn" onClick={prevLesson} disabled={levelIdx === 0 && lessonIdx === 0}>
              Előző
            </button>
            <button className="next-btn" onClick={nextLesson} disabled={levelIdx === curriculum.length - 1 && lessonIdx === level.lessons.length - 1}>
              Következő
            </button>
          </div>
          <button className="back-btn" onClick={onBack} style={{ marginTop: 28 }}>
            Vissza a főmenübe
          </button>
        </div>
      </div>
      <footer style={{
        marginTop: 32,
        textAlign: "center",
        color: "#7a8ca3",
        fontSize: "1rem",
        fontWeight: 500,
        width: "100%"
      }}>
        © Dringocean. All rights reserved.
      </footer>
    </div>
  );
}

// ...existing code...

function AboutDringocean({ onBack }) {
  return (
    <div className="main-bg" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <TopNavBar
        items={[
          { key: "mainmenu", label: "Főmenü", onClick: onBack },
          { key: "languages", label: "Nyelvválasztó" },
          { key: "chapters", label: "Fejezetek" },
          { key: "ai-tutorial", label: "AI Tananyag" },
          { key: "about", label: "Névjegy" },
        ]}
        active="about"
      />
      <div className="center-card" style={{
        padding: 48,
        minWidth: 340,
        maxWidth: 540,
        margin: "auto",
        borderRadius: 32,
        boxShadow: "0 8px 32px rgba(44,62,80,0.13)",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <a
          href="https://dringocean.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "#4f8cff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 28
          }}
        >
          <svg width="90" height="90" viewBox="0 0 90 90" fill="none" style={{marginBottom: 12}}>
            <circle cx="45" cy="45" r="44" fill="#e3f0fc" stroke="#4f8cff" strokeWidth="2"/>
            <path d="M45 22C55 22 65 32 65 45C65 58 55 68 45 68C35 68 25 58 25 45C25 32 35 22 45 22Z" fill="#4f8cff" opacity="0.15"/>
            <text x="50%" y="56%" textAnchor="middle" fill="#4f8cff" fontSize="28" fontWeight="bold" fontFamily="Arial" dy=".3em">Dringocean</text>
          </svg>
          <span style={{ fontSize: "2rem", fontWeight: 800, letterSpacing: "-1px" }}>Dringocean</span>
        </a>
        <div style={{ fontSize: "1.15rem", color: "#2d3a4a", textAlign: "center", marginBottom: 24, maxWidth: 420 }}>
          A Dringocean egy innovatív, oktatási platform, amely a nyelvtanulást és a mesterséges intelligencia megértését teszi élménnyé minden korosztály számára.<br /><br />
          Fedezd fel a tanulás örömét, fejleszd tudásod, és légy részese a digitális jövőnek!
        </div>
        <a
          href="https://dringocean.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: "linear-gradient(90deg, #66a6ff 0%, #89f7fe 100%)",
            color: "#fff",
            fontWeight: 700,
            fontSize: "1.15rem",
            borderRadius: 20,
            padding: "14px 36px",
            textDecoration: "none",
            boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
            marginBottom: 18,
            transition: "background 0.2s"
          }}
        >
          Látogass el a Dringocean oldalára!
        </a>
        <button
          className="back-btn"
          style={{ marginTop: 10, width: "100%" }}
          onClick={onBack}
        >
          Vissza a főmenübe
        </button>
      </div>
      <footer style={{
        marginTop: 32,
        textAlign: "center",
        color: "#7a8ca3",
        fontSize: "1rem",
        fontWeight: 500
      }}>
        © Dringocean. All rights reserved.
      </footer>
    </div>
  );
}

// ...existing code...

export default App;